<template>
  <div class="form">
    <div class="container">
      <!-- Bak btn -->
      <div class="form-container text-left mb-5">
        <button v-if="step > 1" @click="backStep()" class="app-btn px-3">
          Atrás
        </button>
      </div>
      <!-- Step 1 -->
      <div v-if="step == 1" class="form-container text-left">
        <div class="d-flex justify-content-between">
            <span>
              <img src="https://img.icons8.com/material/24/000000/calendar--v1.png"/>
              Fecha de solicitud: {{date.toLocaleDateString("es-Es", options)}}
            </span>
        </div>
        <h2 class="bold">Información General</h2>
        <form class="infoProyecto">
          <div class="input-wrap">
            <label for="name">Operador de red</label>
            <input type="text" id="name" disabled value="EMCALI EICE ESP" style="font-weight:bold; color:red;">
            <label for="name">Nombre de identificación del proyecto</label>
            <input type="text" id="name" v-model="formData.proyectName">
          </div>
        </form>
        <div class="mt-5"> 
          <h3 class="text-center mb-4">Seleccione el tipo de conexión</h3>
          <div class="d-flex justify-content-center flex-column flex-sm-row">
            <!-- <div class="service-box service-box--yellow mb-3 mr-sm-3 mx-auto mx-sm-0 mb-sm-0">
              <div class="service-box-header bg-yellow">
                Conexión simple: : Solicitud de servicio por baja tensión mayor a 30 kVA
              </div>
              <div>
                <ul>
                  <li><a href="#" @click="validateStep1(); 
                    formData.conectionType = 'Simple';
                      formData.serviceDetail.requestedService = '1';
                        formData.serviceDetail.basicDataConexionPoint = 1">Servicio nuevo</a></li>
                  
                  <li><a href="#" @click="validateStep1(); 
                    formData.conectionType = 'Simple';
                      formData.serviceDetail.requestedService = '2';
                        formData.serviceDetail.basicDataConexionPoint = 2">Independizacion de servicios</a></li>
                  
                  <li><a href="#" @click="validateStep1(); 
                    formData.conectionType = 'Simple';
                      formData.serviceDetail.requestedService = '3';
                        formData.serviceDetail.basicDataConexionPoint = 3">Aumento de capacidad</a></li>
                  
                  <li><a href="#" @click="validateStep1(); 
                    formData.conectionType = 'Simple';
                      formData.serviceDetail.requestedService = '4';
                        formData.serviceDetail.basicDataConexionPoint = 4">Provisional</a></li>
                  
                  <li><a href="#" @click="validateStep1(); 
                    formData.conectionType = 'Simple';
                      formData.serviceDetail.requestedService = '5';
                        formData.serviceDetail.basicDataConexionPoint = 5">Reubicación de medidor</a></li>
                  
                  <li><a href="#" @click="validateStep1(); 
                    formData.conectionType = 'Simple';
                      formData.serviceDetail.requestedService = '6';
                        formData.serviceDetail.basicDataConexionPoint = 6">Cambio de tipo de servicio</a></li>
                  
                  <li><a href="#" @click="validateStep1(); 
                    formData.conectionType = 'Simple';
                      formData.serviceDetail.requestedService = '7';
                        formData.serviceDetail.basicDataConexionPoint = 7">Cambio de nivel de tensión en el punto de conexión</a></li>
                </ul>
              </div>
            </div> -->
            <div class="service-box mr-sm-3 m-auto m-sm-0 service-box--blue">
              <div class="service-box-header bg-blue">
                Conexión compleja: Proyectos de energía por media tensión (Nivel de tensión 2 o 3)
              </div>
              <div>
                <ul>
                  <b>Factibilidad (Punto de conexión - datos básicos) :</b>
                  <li title="Seleccionar"><a href="#" @click="validateStep1();
                    formData.conectionType = 'Compleja';
                      formData.serviceDetail.requestedService = 8;
                        formData.serviceDetail.basicDataConexionPoint = 1">Proyecto Nuevo</a></li>

                  <li title="Seleccionar"><a href="#" @click="validateStep1();
                    formData.conectionType = 'Compleja';
                      formData.serviceDetail.requestedService = 8;
                        formData.serviceDetail.basicDataConexionPoint = 2">Aumento de capacidad</a></li>
                  
                  <li title="Seleccionar"><a href="#" @click="validateStep1();
                    formData.conectionType = 'Compleja';
                      formData.serviceDetail.requestedService = 8;
                        formData.serviceDetail.basicDataConexionPoint = 3">Provisional de obra</a></li>

                  <li title="Seleccionar"><a href="#" @click="validateStep1();
                    formData.conectionType = 'Compleja';
                      formData.serviceDetail.requestedService = 8;
                        formData.serviceDetail.basicDataConexionPoint = 4">Modificación de datos básicos</a></li>

                  <li title="Seleccionar"><a href="#" @click="validateStep1();
                    formData.conectionType = 'Compleja';
                      formData.serviceDetail.requestedService = 8;
                        formData.serviceDetail.basicDataConexionPoint = 5">Cambio de nivel de tensión en el punto de conexión</a></li>

                  <li title="Seleccionar"><a href="#" @click="validateStep1();
                    formData.conectionType = 'Compleja';
                      formData.serviceDetail.requestedService = 8;
                        formData.serviceDetail.basicDataConexionPoint = 6">Cambio de nivel de tensión en la medida</a></li>

                  <li title="Seleccionar"><a href="#" @click="validateStep1();
                    formData.conectionType = 'Compleja';
                      formData.serviceDetail.requestedService = 8;
                        formData.serviceDetail.basicDataConexionPoint = 7">Reubicación de redes</a></li>

                  <li title="Seleccionar"><a href="#" @click="validateStep1();
                    formData.conectionType = 'Compleja';
                      formData.serviceDetail.requestedService = 8;
                        formData.serviceDetail.basicDataConexionPoint = 8">Alumbrado público con montaje de transformador</a></li>

                  <li title="Seleccionar"><a href="#" @click="validateStep1();
                    formData.conectionType = 'Compleja';
                      formData.serviceDetail.requestedService = 8;
                        formData.serviceDetail.basicDataConexionPoint = 9">Alumbrado Público para adicionar a transformador existente</a></li>
                </ul>
              </div>
            </div>
            <div class="service-box mr-sm-3 m-auto m-sm-0 service-box--blue">
              <div class="service-box-header bg-blue">
                Certificaciones: Licencia de construcci&oacute;n o Tr&aacute;mite de subsidios
              </div>
              <div>
                <ul>
                  <li title="Para cumplir requisito curaduría urbana. Para cumplir requisito alcaldía municipal">
                    <a href="#" @click="validateStep1(); 
                        formData.conectionType = 'Certificado'; 
                          formData.serviceDetail.requestedService = 9; 
                            formData.serviceDetail.basicDataConexionPoint = ''">Certificación de posibilidad, disponibilidad, Viabilidad del servicio de energía</a>
                  </li>
                  <li title="Proyectos de vivienda de orden municipal">
                      <a href="#" @click="validateStep1(); 
                        formData.conectionType = 'Certificado'; 
                          formData.serviceDetail.requestedService = 10; 
                            formData.serviceDetail.basicDataConexionPoint = ''">Determinantes - plan parcial</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ============= Step 2 ============= -->
      <div v-if="step == 3" class="form-container text-left">
        <div class="d-flex justify-content-between">
            <span>
              <img src="https://img.icons8.com/material/24/000000/calendar--v1.png"/>
              Fecha de solicitud: {{date.toLocaleDateString("es-Es", options)}}
            </span>
            <div class="d-flex">
                <div class="application-number mr-2">
                  Solicitud - <span v-if="formData.conectionType == 'Simple'">UPB</span> <span v-if="formData.conectionType == 'Compleja'">UPM</span> <span v-if="formData.conectionType == 'Certificado'">CERTIFICADO</span>
                </div>
                <!-- <div class="application-number">
                  #001
                </div> -->
            </div>
        </div>
        <h2 class="bold">Datos del solicitante</h2>
          <div class="input-wrap">
            <label>Tipo de documento</label>
            <div class="d-flex align-items-center">
              <div class="radio">
                <input :checked="formData.applicantInfo.documentType == 'CC'" @click="formData.applicantInfo.documentType = 'CC'" id="radio-7"  name="document-type" type="radio">
                <label for="radio-7" class="radio-label">Cédula de ciudadania</label>
              </div>
              <div class="radio">
                <input :checked="formData.applicantInfo.documentType == 'CE'" @click="formData.applicantInfo.documentType = 'CE'" id="radio-8" name="document-type" type="radio">
                <label for="radio-8" class="radio-label">Cédula de extranjería</label>
              </div>
              <div class="radio">
                <input :checked="formData.applicantInfo.documentType == 'Nit'" @click="formData.applicantInfo.documentType = 'Nit'" id="radio-9" name="document-type" type="radio">
                <label for="radio-9" class="radio-label">Nit</label>
              </div>
            </div>
            <div>
              <label for="name">Número de documento</label><br>
              <input class="w-50" @keypress="onlyNumber" inputmode="numeric" onpaste="return false" type="text" id="name" v-model="formData.applicantInfo.documentNumber">
              <div class="alert alert-info">IMPORTANTE: Con este número de documento podrá consultar el estado de su solicitud.</div>
            </div>
            <label for="name">Nombre o razón social</label>
            <input type="text" id="name" v-model="formData.applicantInfo.name">
            <label>Tipo de persona</label>
            <div class="d-flex align-items-center">
              <div class="radio">
                <input :checked="formData.applicantInfo.personType == 'Natural'" @click="formData.applicantInfo.personType = 'Natural'" id="radio-111" name="radio-person-type2" type="radio">
                <label for="radio-111" class="radio-label">Natural</label>
              </div>
              <div class="radio">
                <input :checked="formData.applicantInfo.personType == 'Juridica'" @click="formData.applicantInfo.personType = 'Juridica'" id="radio-222" name="radio-person-type2" type="radio">
                <label for="radio-222" class="radio-label">Jurídica</label>
              </div>
            </div>
            <div v-if="formData.applicantInfo.personType == 'Juridica'">
              <label>Tipo de persona jurídica</label>
              <div class="d-flex align-items-center">
                <div class="radio">
                  <input :checked="formData.applicantInfo.juridicType == 'Estatal'" @click="formData.applicantInfo.juridicType = 'Estatal'" name="radio-juridicType" id="radio-3" type="radio">
                  <label for="radio-3" class="radio-label">Estatal</label>
                </div>
                <div class="radio">
                  <input :checked="formData.applicantInfo.juridicType == 'Privada'" @click="formData.applicantInfo.juridicType = 'Privada'" name="radio-juridicType" id="radio-4" type="radio">
                  <label for="radio-4" class="radio-label">Privada</label>
                </div>
                <div class="radio">
                  <input :checked="formData.applicantInfo.juridicType == 'SinAnimoDeLucro'" @click="formData.applicantInfo.juridicType = 'SinAnimoDeLucro'" name="radio-juridicType" id="radio-5" type="radio">
                  <label for="radio-5" class="radio-label">Sin ánimo de lucro</label>
                </div>
                <div class="radio">
                  <input :checked="formData.applicantInfo.juridicType == 'Mixta'" @click="formData.applicantInfo.juridicType = 'Mixta'" name="radio-juridicType" id="radio-6" type="radio">
                  <label for="radio-6" class="radio-label">Mixta</label>
                </div>
              </div>
            </div>
            <div class="my-3">
              <h3 class="mb-0">Dirección de correspondencia</h3>
              <div class="row mb-2">
                <div class="col">
                  <label for="name">Tipo de via</label>
                  <select name="via-type" id="via-type-1" v-model="formData.applicantInfo.address.streetType">
                    <option value="Calle">Calle</option>
                    <option value="Carrera">Carrera</option>
                    <option value="Avenida">Avenida</option>
                    <option value="Autopista">Autopista</option>
                    <option value="Diagonal">Diagonal</option>
                    <option value="Transversal">Transversal</option>
                  </select>
                </div>
                <div class="col">
                  <label for="name">Via principal</label>
                  <div class="row no-gutters">
                    <div class="col pr-2">
                      <input type="text" id="name" v-model="formData.applicantInfo.address.road1">
                    </div>
                    <div class="col">
                      <select name="street-type" id="via-type-1" v-model="formData.applicantInfo.address.road1Direction">
                        <option value="Norte">Norte</option>
                        <option value="Oeste">Oeste</option>
                        <option value="Bis">Bis</option>
                        <option value="Ninguna">Ninguna</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="direction-separator">
                    #
                  </div>
                  <label for="name">Via secundaria</label>
                  <div class="row no-gutters">
                    <div class="col pr-2">
                      <input type="text" id="name" v-model="formData.applicantInfo.address.road2">
                    </div>
                    <div class="col">
                      <select name="street-type" id="via-type-2" v-model="formData.applicantInfo.address.road2Direction">
                        <option value="Norte">Norte</option>
                        <option value="Oeste">Oeste</option>
                        <option value="Bis">Bis</option>
                        <option value="Ninguna">Ninguna</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="direction-separator">
                    -
                  </div>
                  <label for="streetNumber">Número</label>
                  <input type="text" id="streetNumber" v-model="formData.applicantInfo.address.streetNumber">
                </div>
              </div>
              <label for="name">Número interior/piso (Bloque, Torre, Apartamento, Casa #)</label>
              <input type="text" id="name" v-model="formData.applicantInfo.address.description">
            </div>
            
            <div class="row mb-3">
              <div class="col">
                <label>Comuna</label>
                <input type="text" @keypress="onlyNumber" maxlength="2" v-model="formData.applicantInfo.commune">
              </div>
              <div class="col">
                <label>Municipio</label>
                <input class="uppercase" type="text" v-model="formData.applicantInfo.municipality">
              </div>
              <div class="col">
                <label>Departamento</label>
                <input class="uppercase" type="text" v-model="formData.applicantInfo.department">
              </div>
            </div>
            
            <div class="my-3">
              <h3 class="mb-0">Datos de contacto</h3>
              <div class="row mb-6">
                <div class="col">
                  <label>Email</label>
                  <input type="text" v-model="formData.applicantInfo.email">
                </div>
                <div class="col">
                  <label>Confirmar Email</label>
                  <input onpaste="return false" type="text" v-model="formData.applicantInfo.emailConfirm">
                </div>
              </div>
              

              <div class="row mb-6">
                <div class="col">
                  <div class="alert alert-info">IMPORTANTE: A este email se enviará el código de seguridad para acceder a la consulta de tus solicitudes.</div>
                </div>
              </div>

              <div class="row mb-4">
                <div class="col">
                  <label>Celular</label>
                  <input type="text" @keypress="onlyNumber" maxlength="10" v-model="formData.applicantInfo.celphoneNumber">
                  
                </div>
                <div class="col">
                  <label>Confirmar Celular</label>
                  <input onpaste="return false" type="text" @keypress="onlyNumber" maxlength="10" v-model="formData.applicantInfo.celphoneNumberConfirm">
                </div>
                
                <div class="col">
                  <label>Teléfono Fijo</label>
                  <input type="text" @keypress="onlyNumber" maxlength="10" v-model="formData.applicantInfo.phone">
                </div>
              </div>
            </div>


            <div>
              <label>¿Autoriza la notificación mediante correo electrónico?</label>
              <div class="d-flex align-items-center">
                <div class="radio">
                  <input :checked="formData.applicantInfo.mailNotificationsAuth == 1" @click="formData.applicantInfo.mailNotificationsAuth = 1" id="mailnotifications1si" name="mailnotifications1" type="radio">
                  <label for="mailnotifications1si" class="radio-label">Si</label>
                </div>
                <div class="radio">
                  <input :checked="formData.applicantInfo.mailNotificationsAuth == 0" @click="formData.applicantInfo.mailNotificationsAuth = 0" id="mailnotifications1no" name="mailnotifications1" type="radio">
                  <label for="mailnotifications1no" class="radio-label">No</label>
                </div>
              </div>
            </div>

            <div v-if="formData.conectionType == 'Simple' || formData.conectionType == 'Compleja'" class="mb-3">
              <label>¿El solicitante es el propietario del predio?</label>
              <div class="d-flex align-items-center">
                <div class="radio">
                  <input :checked="formData.applicantInfo.solicitantSameSubscriptor == 1" @click="formData.applicantInfo.solicitantSameSubscriptor = 1" id="usersolsi" name="usersol" type="radio">
                  <label for="usersolsi" class="radio-label">Si</label>
                </div>
                <div class="radio">
                  <input :checked="formData.applicantInfo.solicitantSameSubscriptor == 0" @click="formData.applicantInfo.solicitantSameSubscriptor = 0" id="usersolno" name="usersol" type="radio">
                  <label for="usersolno" class="radio-label">No</label>
                </div>
              </div>
            </div>
            <div>
              <div class="alert alert-info">El documento debe estar en buena calidad y preferiblemente en formato (PDF)</div>
              <div v-if="formData.applicantInfo.solicitantSameSubscriptor == 1">
                <div v-if="formData.applicantInfo.personType == 'Natural'" class="mb-3">
                  <label class="file">Fotocopia del documento de identidad del solicitante<v-icon class="ml-2" name="upload" scale="1.5"/>
                    <input @change="onFileChangeIdDocApplicant($event)" type="file" >
                    <div class="file-selected" v-if="formData.applicantInfo.idDocumentCopy">
                      {{formData.applicantInfo.idDocumentCopyFile.name}} - 
                    <button type="button" class="close" @click="confirmedDoc = true; validarInputDocument()">
                      <span><v-icon class="ml-1" name="trash" scale="1.5"/></span>
                    </button>
                    </div>
                  </label> 
                </div>
                <div v-if="formData.applicantInfo.personType == 'Juridica'" class="mb-3">
                  <label class="file">Cédula de ciudadanía de la persona natural o representante legal <v-icon class="ml-2" name="upload" scale="1.5"/>
                    <input @change="onFileChangeIdDocApplicant($event)" type="file" >
                    <div class="file-selected" v-if="formData.applicantInfo.idDocumentCopy">
                      {{formData.applicantInfo.idDocumentCopyFile.name}}-
                      <button type="button" class="close" @click="confirmedDoc = true; validarInputDocument()">
                      <span><v-icon class="ml-1" name="trash" scale="1.5"/></span>
                    </button>
                    </div>
                  </label> 
                </div>
                <div v-if="formData.applicantInfo.personType == 'Juridica'" class="mb-3">
                  <label class="file">Certificado de cámara y comercio <v-icon class="ml-2" name="upload" scale="1.5"/>
                    <input @change="onFileChangeCamaraComercio($event)" type="file" >
                    <div class="file-selected" v-if="formData.applicantInfo.camaraComercio">
                      {{formData.applicantInfo.camaraComercioFile.name}} - 
                      <button type="button" class="close" @click="confirmedCamara = true; validarInputDocumentCamara()">
                      <span><v-icon class="ml-1" name="trash" scale="1.5"/></span>
                    </button>
                    </div>
                  </label> 
                </div>
              </div>
              <div v-if="formData.applicantInfo.solicitantSameSubscriptor == 0">
                <div v-if="formData.applicantInfo.personType == 'Natural'" class="mb-3">
                  <label class="file">Fotocopia del documento de identidad <v-icon class="ml-2" name="upload" scale="1.5"/>
                    <input @change="onFileChangeIdDocApplicant($event)" type="file" >
                    <div class="file-selected" v-if="formData.applicantInfo.idDocumentCopy">
                      {{formData.applicantInfo.idDocumentCopyFile.name}} -
                      <button type="button" class="close" @click="confirmedDoc = true; validarInputDocument()">
                      <span><v-icon class="ml-1" name="trash" scale="1.5"/></span>
                    </button>
                    </div>
                  </label> 
                </div>
                <div v-if="formData.applicantInfo.personType == 'Juridica'" class="mb-3">
                  <label class="file">Cédula de ciudadanía de la persona natural o representante legal <v-icon class="ml-2" name="upload" scale="1.5"/>
                    <input @change="onFileChangeIdDocApplicant($event)" type="file" >
                    <div class="file-selected" v-if="formData.applicantInfo.idDocumentCopy">
                      {{formData.applicantInfo.idDocumentCopyFile.name}} -
                      <button type="button" class="close" @click="confirmedDoc = true; validarInputDocument()">
                      <span><v-icon class="ml-1" name="trash" scale="1.5"/></span>
                    </button>
                    </div>
                  </label> 
                </div>
                <div class="mb-3">
                  <label class="file">Carta de autorización por parte del propietario.<v-icon class="ml-2" name="upload" scale="1.5"/>
                    <input @change="onFileChangeAuthLetter($event)" type="file">
                    <div class="file-selected" v-if="formData.applicantInfo.authLetter">
                      {{formData.applicantInfo.authLetterFile.name}} - 
                      <button type="button" class="close" @click="confirmedAuth = true; validarInputDocumentAuth()">
                      <span><v-icon class="ml-1" name="trash" scale="1.5"/></span>
                    </button>
                    </div>
                  </label> 
                </div>                
                <div v-if="formData.applicantInfo.personType == 'Juridica'" class="mb-3">
                  <label class="file">Certificado de cámara y comercio <v-icon class="ml-2" name="upload" scale="1.5"/>
                    <input @change="onFileChangeCamaraComercio($event)" type="file" >
                    <div class="file-selected" v-if="formData.applicantInfo.camaraComercio">
                      {{formData.applicantInfo.camaraComercioFile.name}} - 
                      <button type="button" class="close" @click="confirmedCamara = true; validarInputDocumentCamara()">
                      <span><v-icon class="ml-1" name="trash" scale="1.5"/></span>
                    </button>
                    </div>
                  </label> 
                </div>
              </div>
            </div>
            <div>
              <button @click="validateStep2()" class="app-btn px-4 ml-auto">Continuar</button>
            </div>
          </div>
      </div>

      <!-- ============ Step 3 ============ -->
      <div v-if="step == 4" class="form-container text-left">
        <div class="d-flex justify-content-between">
          <span>
            <img src="https://img.icons8.com/material/24/000000/calendar--v1.png"/>
              Fecha de solicitud: {{date.toLocaleDateString("es-Es", options)}}
          </span>
          <div class="d-flex">
            <div class="application-number mr-2">
              Solicitud - <span v-if="formData.conectionType == 'Simple'">UPB</span> <span v-if="formData.conectionType == 'Compleja'">UPM</span> <span v-if="formData.conectionType == 'Certificado'">CERTIFICADO</span>
            </div>
              <!-- <div class="application-number">
                001
              </div> -->
          </div>
        </div>
        <h2 class="bold">Datos del Suscriptor/Usuario</h2>
          <div class="input-wrap">
            <label for="name">Nombre o razón social</label>
            <input type="text" id="name" v-model="formData.subscriptorInfo.name">
            <label>Tipo de persona</label>
            <div class="d-flex align-items-center">
              <div class="radio">
                <input :checked="formData.subscriptorInfo.personType == 'Natural'" @click="formData.subscriptorInfo.personType = 'Natural'" id="radio-s-1" name="radio-person-type" type="radio">
                <label for="radio-s-1" class="radio-label">Natural</label>
              </div>
               <div class="radio">
                 <input :checked="formData.subscriptorInfo.personType == 'Juridica'" @click="formData.subscriptorInfo.personType = 'Juridica'" id="radio-s-2" name="radio-person-type" type="radio">
                 <label for="radio-s-2" class="radio-label">Jurídica</label>
               </div>
             </div>
             <div v-if="formData.subscriptorInfo.personType == 'Juridica'">
               <label>Tipo de persona Jurídica</label>
               <div class="d-flex align-items-center">
                 <div class="radio">
                   <input :checked="formData.subscriptorInfo.juridicType == 'Estatal'" @click="formData.subscriptorInfo.juridicType = 'Estatal'" id="radio-s-3" name="juridic-type" type="radio">
                   <label for="radio-s-3" class="radio-label">Estatal</label>
                 </div>
                 <div class="radio">
                   <input :checked="formData.subscriptorInfo.juridicType == 'Privada'" @click="formData.subscriptorInfo.juridicType = 'Privada'" id="radio-s-4" name="juridic-type" type="radio">
                   <label for="radio-s-4" class="radio-label">Privada</label>
                 </div>
                 <div class="radio">
                   <input :checked="formData.subscriptorInfo.juridicType == 'SinAnimoDeLucro'" @click="formData.subscriptorInfo.juridicType = 'SinAnimoDeLucro'" id="radio-s-5" name="juridic-type" type="radio">
                   <label for="radio-s-5" class="radio-label">Sin ánimo de lucro</label>
                 </div>
                 <div class="radio">
                   <input :checked="formData.subscriptorInfo.juridicType == 'Mixta'" @click="formData.subscriptorInfo.juridicType = 'Mixta'" id="radio-s-6" name="juridic-type" type="radio">
                   <label for="radio-s-6" class="radio-label">Mixta</label>
                 </div>
               </div>
             </div>
             <label>Tipo de documento</label>
             <div class="d-flex align-items-center">
               <div class="radio">
                 <input :checked="formData.subscriptorInfo.documentType == 'CC'" @click="formData.subscriptorInfo.documentType = 'CC'" id="radio-7" name="document-type" type="radio">
                 <label for="radio-7" class="radio-label">Cédula de ciudadania</label>
               </div>
               <div class="radio">
                 <input :checked="formData.subscriptorInfo.documentType == 'CE'" @click="formData.subscriptorInfo.documentType = 'CE'" id="radio-8" name="document-type" type="radio">
                 <label for="radio-8" class="radio-label">Cédula de extranjería</label>
               </div>
               <div class="radio">
                 <input :checked="formData.subscriptorInfo.documentType == 'Nit'" @click="formData.subscriptorInfo.documentType = 'Nit'" id="radio-9" name="document-type" type="radio">
                 <label for="radio-9" class="radio-label">Nit</label>
               </div>
             </div>
             <label for="name">Número de documento</label><br>
             <input class="w-50" @keypress="onlyNumber" type="text" id="name" v-model="formData.subscriptorInfo.documentNumber">
             <div class="my-3">
               <h3 class="mb-0">Dirección de correspondencia</h3>
               <div class="row mb-2">
                  <div class="col">
                    <label for="via-type-s">Tipo de via</label>
                    <select name="via-type" id="via-type-s" v-model="formData.subscriptorInfo.address.streetType">
                      <option value="Calle">Calle</option>
                      <option value="Carrera">Carrera</option>
                      <option value="Avenida">Avenida</option>
                      <option value="Autopista">Autopista</option>
                      <option value="Diagonal">Diagonal</option>
                      <option value="Transversal">Transversal</option>
                    </select>
                  </div>
                 <div class="col">
                   <label for="name">Via principal</label>
                   <div class="row no-gutters">
                     <div class="col pr-2">
                       <input type="text" id="name" v-model="formData.subscriptorInfo.address.road1">
                     </div>
                    <div class="col">
                       <select name="street-type" id="via-type-1" v-model="formData.subscriptorInfo.address.road1Direction">
                         <option value="Norte">Norte</option>
                         <option value="Oeste">Oeste</option>
                         <option value="Bis">Bis</option>
                         <option value="Ninguna">Ninguna</option>
                       </select>
                     </div>
                   </div>
                 </div>
                 <div class="col">
                   <div class="direction-separator">
                     #
                   </div>
                   <label for="name">Via secundaria</label>
                   <div class="row no-gutters">
                     <div class="col pr-2">
                       <input type="text" id="name" v-model="formData.subscriptorInfo.address.road2">
                     </div>
                     <div class="col">
                       <select name="street-type" id="via-type-1" v-model="formData.subscriptorInfo.address.road2Direction">
                         <option value="Norte">Norte</option>
                         <option value="Oeste">Oeste</option>
                         <option value="Bis">Bis</option>
                         <option value="Ninguna">Ninguna</option>
                       </select>
                     </div>
                   </div>
                 </div>
                 <div class="col">
                   <div class="direction-separator">
                     #
                   </div>
                   <label for="name">Número</label>
                   <input type="text" id="name" v-model="formData.subscriptorInfo.address.streetNumber">
                 </div>
               </div>
               <label for="name">Número interior/piso (Bloque, Torre, Apartamento, Casa #)</label>
               <input type="text" id="name" v-model="formData.subscriptorInfo.address.description">
             </div>
             <div class="row mb-3">
               <div class="col">
                 <label for="name">Comuna</label>
                 <input type="text" maxlength="2" @keypress="onlyNumber" id="name" v-model="formData.subscriptorInfo.commune">
               </div>
               <div class="col">
                 <label for="name">Municipio</label>
                 <input class="uppercase" type="text" id="name" v-model="formData.subscriptorInfo.municipality">
               </div>
               <div class="col">
                 <label for="name">Departamento</label>
                 <input class="uppercase" type="text" id="name"  v-model="formData.subscriptorInfo.department">
               </div>
             </div>      

            <div class="my-3">
              <h3 class="mb-0">Datos de contacto</h3>
              <div class="row mb-6">
                <div class="col">
                  <label>Email</label>
                  <input type="text" v-model="formData.subscriptorInfo.email">
                </div>
                <div class="col">
                  <label>Confirmar Email</label>
                  <input onpaste="return false" type="text" v-model="formData.subscriptorInfo.emailConfirm">
                </div>
              </div>
              <div class="row mb-4">
                <div class="col">
                  <label>Celular</label>
                  <input type="text" @keypress="onlyNumber" maxlength="10" v-model="formData.subscriptorInfo.celphoneNumber">                  
                </div>
                <div class="col">
                  <label>Confirmar Celular</label>
                  <input onpaste="return false" type="text" @keypress="onlyNumber" maxlength="10" v-model="formData.subscriptorInfo.celphoneNumberConfirm">
                </div>
                <div class="col">
                  <label>Teléfono Fijo</label>
                  <input type="text" @keypress="onlyNumber" maxlength="10" v-model="formData.subscriptorInfo.phone">
                </div>
              </div>              
            </div>
             <div class="mb-3">
               <label>¿Autoriza la notificación mediante correo electrónico?</label>
               <div class="d-flex align-items-center">
                 <div class="radio">
                   <input @click="formData.subscriptorInfo.mailNotificationsAuth = 1" id="mailnotifications1si" name="mailnotifications1" type="radio" checked>
                   <label for="mailnotifications1si" class="radio-label">Si</label>
                 </div>
                 <div class="radio">
                   <input @click="formData.subscriptorInfo.mailNotificationsAuth = 0" id="mailnotifications1no" name="mailnotifications1" type="radio">
                   <label for="mailnotifications1no" class="radio-label">No</label>
                 </div>
               </div>
             </div>
             <div class="alert alert-info">El documento debe estar en buena calidad y preferiblemente en formato (PDF)</div>
             <div v-if="formData.subscriptorInfo.personType == 'Natural'" class="mb-3">
               <label class="file">Fotocopia del documento de identidad <v-icon class="ml-3" name="upload" scale="1.5"/>
                 <input @change="onFileChangeIdDocSubscriptor($event)" type="file" >
                 <div class="file-selected" v-if="formData.subscriptorInfo.idDocumentCopy">
                   {{formData.subscriptorInfo.idDocumentCopyFile.name}}
                 </div>
               </label> 
             </div>
             <div v-if="formData.subscriptorInfo.personType == 'Juridica'" class="mb-3">
               <label class="file">Cédula de ciudadanía de la persona natural o representante legal <v-icon class="ml-3" name="upload" scale="1.5"/>
                 <input @change="onFileChangeIdDocSubscriptor($event)" type="file" >
                 <div class="file-selected" v-if="formData.subscriptorInfo.idDocumentCopy">
                   {{formData.subscriptorInfo.idDocumentCopyFile.name}}
                 </div>
               </label> 

               <label class="file mt-3">Certificado de cámara y comercio <v-icon class="ml-2" name="upload" scale="1.5"/>
                    <input @change="onFileChangeCamaraComerciosuscriptor($event)" type="file" >
                    <div class="file-selected" v-if="formData.subscriptorInfo.camaraComercio">
                      {{formData.subscriptorInfo.camaraComercioFile.name}} - 
                      <button type="button" class="close" @click="confirmedCamara = true; validarInputDocumentCamara()">
                        <span><v-icon class="ml-1" name="trash" scale="1.5"/></span>
                      </button>
                    </div>
                  </label>
             </div>
             </div>
        <div>
          <button @click="validateStep3()" class="app-btn px-4 ml-auto">Continuar</button>
        </div>
      </div>


      <!-- ============ Step 4 ============ -->
      <div v-if="step == 5" class="form-container text-left">
        <div class="d-flex justify-content-between">
            <span>
              <img src="https://img.icons8.com/material/24/000000/calendar--v1.png"/>
              Fecha de solicitud: {{date.toLocaleDateString("es-Es", options)}}
            </span>
            <div class="d-flex">
                <div class="application-number mr-2">
                  Solicitud - <span v-if="formData.conectionType == 'Simple'">UPB</span> <span v-if="formData.conectionType == 'Compleja'">UPM</span> <span v-if="formData.conectionType == 'Certificado'">CERTIFICADO</span>
                </div>
            </div>
        </div>
        <h2 v-if="formData.serviceDetail.basicDataConexionPoint != '8' && formData.serviceDetail.basicDataConexionPoint != '9'" class="bold">Datos del Predio</h2>
        <h2 v-if="formData.serviceDetail.basicDataConexionPoint == '8' || formData.serviceDetail.basicDataConexionPoint == '9'" class="bold">Datos de Ubicación del Alumbrado Público</h2>
          <div class="input-wrap">
            <label>Zona</label>
            <div :class="{'mb-3':formData.conectionType == 'Simple'}" class="d-flex align-items-center">
              <div class="radio">
                <input :checked="formData.estateInfo.zoneType == 'Urbana'" @click="formData.estateInfo.zoneType = 'Urbana'" id="radio-zonetype-1" name="radio-zone-type" type="radio">
                <label for="radio-zonetype-1" class="radio-label">Urbana</label>
              </div>
              <div class="radio">
                <input :checked="formData.estateInfo.zoneType == 'Rural'" @click="formData.estateInfo.zoneType = 'Rural'" id="radio-zonetype-2" name="radio-zone-type" type="radio">
                <label for="radio-zonetype-2" class="radio-label">Rural</label>
              </div>
            </div>
            <div v-if="formData.conectionType == 'Simple'" class="mb-3">
              <label for="predioNumber">Número de predial</label><br>
              <input type="text" id="predioNumber" v-model="formData.estateInfo.predioNumber">
            </div>
            <div class="mb-3"  v-if="formData.conectionType != 'Compleja'"> 
              <label for="nieNumber">Número de cuenta NIE - (contrato)</label><br>
              <input type="text" id="nieNumber" v-model="formData.estateInfo.nieAccountNumber">
            </div>    
            <div class="row mb-6" v-if="formData.conectionType != 'Compleja'">
                <div class="col">
                  <div class="alert alert-info">IMPORTANTE: Diligenciar sólo si existe conexión en el predio.</div>
                </div>
              </div>        
            <div class="mb-3" v-if="formData.conectionType != 'Compleja'">
                <label>Matrícula Inmobiliaria</label>
                <input v-model="formData.serviceDetail.realStateRegistration" type="text">
              </div>
            <div v-if="formData.estateInfo.zoneType == 'Rural'">
              <h3 class="mb-0"> Ubicación georreferenciada Google Maps </h3>
              <div class="row mb-3">
                <div class="col">
                  <label for="latitud">Latitud (N)</label><br>
                  <input type="text" id="latitud" v-model="formData.estateInfo.latitud">
                </div>
                <div class="col">
                  <label for="longitud">Longitud (W)</label><br>
                  <input type="text" id="longitud" v-model="formData.estateInfo.longitud">
                </div>
                <div class="col">
                  <label for="altura">Altura (h) </label><br>
                    <select name="altura" id="altura" v-model="formData.estateInfo.height">
                      <option value="Cali (1018m)">Cali (1018m)</option>
                      <option value="Yumbo (995m)">Yumbro (995m)</option>
                      <option value="Puerto Tejada (968m)">Puerto Tejada (968m)</option>
                    </select>
                </div>
              </div>
              <label v-if="formData.serviceDetail.basicDataConexionPoint != '8' && formData.serviceDetail.basicDataConexionPoint != '9'" for="indications">Indicaciones de acceso al predio</label>
              <label v-if="formData.serviceDetail.basicDataConexionPoint == '8' || formData.serviceDetail.basicDataConexionPoint == '9'" for="indications">Indicaciones adicionales</label>
              <textarea id="indications" cols="30" rows="5" v-model="formData.estateInfo.indications"></textarea>
            </div>
            <div v-if="formData.estateInfo.zoneType == 'Urbana'" class="my-3">
              <h3 class="mb-0">Dirección del predio</h3>
              <div class="row mb-2">
                <div class="col">
                  <label for="estateStreetType">Tipo de via</label>
                  <select name="via-type" id="estateStreetType" v-model="formData.estateInfo.address.streetType">
                    <option value="Calle">Calle</option>
                    <option value="Carrera">Carrera</option>
                    <option value="Avenida">Avenida</option>
                    <option value="Autopista">Autopista</option>
                    <option value="Diagonal">Diagonal</option>
                    <option value="Transversal">Transversal</option>
                  </select>
                </div>
                <div class="col">
                  <label for="name">Via principal</label>
                  <div class="row no-gutters">
                    <div class="col pr-2">
                      <input type="text" id="name" v-model="formData.estateInfo.address.road1">
                    </div>
                    <div class="col">
                      <select name="street-type" v-model="formData.estateInfo.address.road1Direction">
                        <option value="Norte">Norte</option>
                        <option value="Oeste">Oeste</option>
                        <option value="Bis">Bis</option>
                        <option value="Ninguna">Ninguna</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="direction-separator">
                    #
                  </div>
                  <label for="stateInfoRoad2">Via secundaria</label>
                  <div class="row no-gutters">
                    <div class="col pr-2">
                      <input type="text" id="stateInfoRoad2" v-model="formData.estateInfo.address.road2">
                    </div>
                    <div class="col">
                      <select name="street-type" id="via-type-1" v-model="formData.estateInfo.address.road2Direction">
                        <option value="Norte">Norte</option>
                        <option value="Oeste">Oeste</option>
                        <option value="Bis">Bis</option>
                        <option value="Ninguna">Ninguna</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="direction-separator">
                    -
                  </div>
                  <label for="estateInfoStreetNumber">Número</label>
                  <input type="text" id="estateInfoStreetNumber" v-model="formData.estateInfo.address.streetNumber">
                </div>
              </div>
              <label for="estateInfoDescription">Número interior/piso (Bloque, Torre, Apartamento, Casa #)</label>
              <input type="text" id="estateInfoDescription" v-model="formData.estateInfo.address.description">
            </div>
            <div class="row mb-3">
              <div class="col">
                <label for="estateInfoCommune">Comuna</label>
                <select name="street-type" id="estateInfoCommune" v-model="formData.estateInfo.commune">
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                  <option value="7">7</option>
                  <option value="8">8</option>
                  <option value="9">9</option>
                  <option value="10">10</option>
                  <option value="11">11</option>
                  <option value="12">12</option>
                  <option value="13">13</option>
                  <option value="14">14</option>
                  <option value="15">15</option>
                  <option value="16">16</option>
                  <option value="17">17</option>
                  <option value="18">18</option>
                  <option value="19">19</option>
                  <option value="20">20</option>
                  <option value="21">21</option>
                  <option value="22">22</option>
                  <option value="23">Yumbo</option>
                  <option value="25">Jamundí</option>
                  <option value="25">Pto tejada</option>
                </select>
              </div>
              <div class="col">
                <label for="estateInfoMunicipality">Municipio</label>
                <select name="street-type" id="estateInfoMunicipality" v-model="formData.estateInfo.municipality">
                  <option value="Cali">Santiago de Cali</option>
                  <option value="Yumbo">Yumbo</option>
                  <option value="Jamundí">Jamundí</option>
                  <option value="Pto tejada">Pto tejada</option>
                </select>
              </div>
              <div class="col">
                <label for="estateInfoDepartment">Departamento</label>
                <select name="street-type" id="estateInfoDepartment" v-model="formData.estateInfo.department">
                  <option value="Valle del Cauca">Valle del Cauca</option>
                  <option value="Cauca">Cauca</option>
                </select>
              </div>
            </div>

            <div v-if="formData.estateInfo.existentEstate == true" class="my-3">
              <label class="file"> Certificado de Libertad y Tradición con fecha menor a 15 días  <v-icon name="upload" scale="1.5"/>
                <input type="file" @change="onFileChangeEstateInfoCert($event)">
                <div class="file-selected" v-if="formData.estateInfo.estateInfoCert">
                  {{formData.estateInfo.estateInfoCertFile.name}}
                </div>
              </label> 
            </div>
            
            <div>
              <button @click="validateStep4()" class="app-btn px-4 ml-auto">Continuar</button>
            </div>
          </div>
      </div>

      <!-- ============ Step 5 ============ -->
      <div v-if="step == 6" class="form-container text-left">
        <div class="d-flex justify-content-between">
            <span>
              <img src="https://img.icons8.com/material/24/000000/calendar--v1.png"/>
              Fecha de solicitud: {{date.toLocaleDateString("es-Es", options)}}
            </span>
            <div class="d-flex">
                <div class="application-number mr-2">
                  Solicitud - <span v-if="formData.conectionType == 'Simple'">UPB</span> <span v-if="formData.conectionType == 'Compleja'">UPM</span> <span v-if="formData.conectionType == 'Certificado'">CERTIFICADO</span>
                </div>
            </div>
        </div>


        <h2 class="bold">Tipos de uso y actividad económica</h2>
          <div class="input-wrap">
            <div class="my-3">
              <div class="row mb-3">
                <div class="col">
                  <label for="typeUse">Tipo de uso</label>
                  <select name="use-type" id="typeUse" v-model="formData.typesOfUseAndEconomicActivity.typeUse">
                    <option value="Residencial">Residencial</option>
                    <option value="Comercial">Comercial</option>
                    <option value="industrial">Industrial</option>
                    <option value="Oficial">Oficial</option>
                  </select>
                </div>
                <div class="col" v-if="formData.typesOfUseAndEconomicActivity.typeUse == 'Residencial'">
                  <label for="residencialType">Tipo de proyecto a realizar</label>
                  <select name="residencialType" id="residencialType" v-model="formData.typesOfUseAndEconomicActivity.residencialType">
                    <option value="Lotes">Lotes</option>
                    <option value="Viviendas">Viviendas</option>
                    <option value="Apartamentos">Apartamentos</option>
                  </select>
                </div>
                <div class="col">
                  <label for="socioEconomic">Estrato socioeconómico</label>
                  <select name="socioEconomic" id="socioEconomic" v-model="formData.typesOfUseAndEconomicActivity.socioEconomic">
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="mt-3">
              <button @click="validateStep5()" class="app-btn px-4 ml-auto">Continuar</button>
            </div>
          </div>
      </div>

      <!-- ============ Step 6 ============ -->
      <div v-if="step == 7" class="form-container text-left">
        <div class="d-flex justify-content-between mb-3">
            <span>
              <img src="https://img.icons8.com/material/24/000000/calendar--v1.png"/>
              Fecha de solicitud: {{date.toLocaleDateString("es-Es", options)}}
            </span>
            <div class="d-flex">
                <div class="application-number mr-2">
                  Solicitud - <span v-if="formData.conectionType == 'Simple'">UPB</span> <span v-if="formData.conectionType == 'Compleja'">UPM</span> <span v-if="formData.conectionType == 'Certificado'">CERTIFICADO</span>
                </div>
            </div>
        </div>
        <h2 class="bold">Datos de infraestructura eléctrica actual</h2>
        <div class="input-wrap">
          <div class="my-3">
            <label for="name">¿Hay red eléctrica cercana al predio?</label>
            <div class="d-flex align-items-center">
              <div class="radio">
                <input :checked="formData.electricInfrastructure.closeElectricRed == 1" @click="formData.electricInfrastructure.closeElectricRed = 1" id="closeElectricRedTrue" name="radio-person-type" type="radio">
                <label for="closeElectricRedTrue" class="radio-label">Si</label>
              </div>
              <div class="radio">
                <input :checked="formData.electricInfrastructure.closeElectricRed == 0" @click="formData.electricInfrastructure.closeElectricRed = 0" id="closeElectricRedFalse" name="radio-person-type" type="radio">
                <label for="closeElectricRedFalse" class="radio-label">No</label>
              </div>
            </div>
          </div>
          <div class="row" v-if="formData.electricInfrastructure.closeElectricRed == 1">
            <div class="col">
              <div>
                <label for="redDistance">Distancia actual del predio a la red más cercana (Mts)</label>
                <input type="text" id="redDistance" @keypress="onlyNumber" v-model="formData.electricInfrastructure.redDistance">
              </div>
            </div>
            <div class="col">
              <div>
                <label for="transformerNumber">Número de nodo más cercano</label>
                <input type="text" id="transformerNumber" @keypress="onlyNumber" maxlength="7" v-model="formData.electricInfrastructure.transformerNumber">
              </div>
            </div>
          </div>
          <div class="mt-3">
            <button @click="validateStep6()" class="app-btn px-4 ml-auto">Continuar</button>
          </div>
        </div>
      </div>

      <!-- ============ Step 2 ============ -->
      <div v-if="step == 2" class="form-container text-left">
        <div class="d-flex justify-content-between mb-3">
            <span>
              <img src="https://img.icons8.com/material/24/000000/calendar--v1.png"/>
              Fecha de solicitud: {{date.toLocaleDateString("es-Es", options)}}
            </span>
            <div class="d-flex">
                <div class="application-number mr-2">
                  Solicitud - <span v-if="formData.conectionType == 'Simple'">UPB</span> <span v-if="formData.conectionType == 'Compleja'">UPM</span> <span v-if="formData.conectionType == 'Certificado'">CERTIFICADO</span>
                </div>
            </div>
        </div>
        <h4 class="bold">Detalle del servicio</h4>
        
        <div class="input-wrap">
          <div class="my-3" v-if="formData.conectionType == 'Simple'">
            <label for="requestedService">Tipo de servicio solicitado</label>
            <select name="requestedService" id="requestedService" v-model="formData.serviceDetail.requestedService">
              <option value="1">Servicio nuevo</option>
              <option value="2">Independización de servicios</option>
              <option value="3">Aumento de capacidad</option>
              <option value="4">Provisional</option>
              <option value="5">Reubicación de medidor</option>
              <option value="6">Cambio de tipo de servicio</option>
              <option value="7">Cambio de nivel de tensión en el punto de conexión</option>
            </select>
          </div>

          <div v-if="formData.serviceDetail.requestedService == '10'">
            <div class="row mb-3">
              <div class="col">
                <label>Matrícula Inmobiliaria</label>
                <input v-model="formData.serviceDetail.realStateRegistration" type="text">
              </div>
              <div class="col">
                <label>Número de predial</label>
                <input v-model="formData.serviceDetail.areaMt2" type="text">
              </div>
              <div class="col">
                <label for="numberOfUsers">Número de usuarios</label>
                <input type="text" @keypress="onlyNumber" id="numberOfUsers" v-model="formData.serviceDetail.numbeUsers">
              </div>
            </div>
            <div class="row mb-4">
              <div class="col">
                <label for="">Nodo de referencia</label>
                <input type="text" maxlength="7" v-model="formData.serviceDetail.nodoReference">
              </div>
              <div class="col">
                <label for="">Capacidad en kVA Solicitada</label>
                <input type="text" v-model="formData.serviceDetail.capacityKvaSolicited">
              </div>
            </div>
          </div>
          <div v-if="formData.serviceDetail.requestedService == '9'">
            <div class="row mb-3">
              <div class="col">
                <label>Matrícula Inmobiliaria</label>
                <input v-model="formData.serviceDetail.realStateRegistration" type="text">
              </div>
              <div class="col">
                <label>Número de predial</label>
                <input type="text" v-model="formData.serviceDetail.areaMt2">
              </div>
              <div class="col">
                <label for="">Número de usuarios</label>
                <input type="text" @keypress="onlyNumber" v-model="formData.serviceDetail.numbeUsers">
              </div>
              <div class="col">
                <label for="">Nodo de referencia</label>
                <input type="text" maxlength="7" v-model="formData.serviceDetail.nodoReference">
              </div>
            </div>
          </div>
          <div class="mb-3" v-if="formData.serviceDetail.requestedService == '8'">
          <!--  <div class="mb-3"> -->
            <label for="requestedService">Seleccione de acuerdo al tipo de proyecto.</label>
            <select name="socioeconomic" id="requestedService" v-model="formData.serviceDetail.basicDataConexionPoint">
              <option value="1">Proyecto Nuevo</option>
              <option value="2">Aumento de capacidad</option>
              <option value="10">Disminución de capacidad</option>
              <option value="3">Provisional de obra</option>
              <option value="4">Modificación de datos básicos</option>
              <option value="5">Cambio de nivel de tensión en el punto de conexión</option>
              <option value="6">Cambio de nivel de tensión en la medida</option>
              <option value="7">Reubicación de redes</option>
              <option value="8">Alumbrado público con montaje de transformador</option>
              <option value="9">Alumbrado Público para adicionar a transformador existente</option>
            </select>
          </div>
          <div v-if="formData.conectionType == 'Compleja'" class="mb-3">
            <label>Nivel de tensión solicitado</label>
            <select name="tensionRequested" id="tensionRequested" v-model="formData.serviceDetail.tensionRequested">
              <option value="1"  v-if="formData.conectionType != 'Compleja'">Nivel 1. Tensión menor a 1 kV </option>
              <option value="2">Nivel 2. Tensión mayor o igual a 1 kV y menor a 30 kV</option>
              <option value="3">Nivel 3. Tensión mayor o igual a 30 kV y menor a 57.5 kV</option>
            </select>
          </div> 
          
          <div id="listorder"  v-if="formData.conectionType == 'Simple'">  
            <label>Número de cuentas por tipo  y clase de carga</label>
              <table class="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th scope="col">Tipo de Carga</th>
                    <th scope="col">Monofásicas</th>
                    <th scope="col">Bifásicas</th>
                    <th scope="col">Trifásicas</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Residenciales</td>
                    <td><input type="text" v-model="valoresTiposCarga.residencial[0]"></td>
                    <td><input type="text" v-model="valoresTiposCarga.residencial[1]"></td>
                    <td><input type="text" v-model="valoresTiposCarga.residencial[2]"></td>
                  </tr>
                  <tr>
                    <td>Comerciales</td>
                    <td><input type="text" v-model="valoresTiposCarga.comercial[0]"></td>
                    <td><input type="text" v-model="valoresTiposCarga.comercial[1]"></td>
                    <td><input type="text" v-model="valoresTiposCarga.comercial[2]"></td>
                  </tr>
                  <tr>
                    <td>Industriales</td>
                    <td><input type="text" v-model="valoresTiposCarga.industrial[0]"></td>
                    <td><input type="text" v-model="valoresTiposCarga.industrial[1]"></td>
                    <td><input type="text" v-model="valoresTiposCarga.industrial[2]"></td>
                  </tr>
                  <tr>
                    <td>Oficiales</td>
                    <td><input type="text" v-model="valoresTiposCarga.oficial[0]"></td>
                    <td><input type="text" v-model="valoresTiposCarga.oficial[1]"></td>
                    <td><input type="text" v-model="valoresTiposCarga.oficial[2]"></td>
                  </tr>
                  <tr>
                    <td>Alumbrado público</td>
                    <td><input type="text" v-model="valoresTiposCarga.alumbradoPublico[0]"></td>
                    <td><input type="text" v-model="valoresTiposCarga.alumbradoPublico[1]"></td>
                    <td><input type="text" v-model="valoresTiposCarga.alumbradoPublico[2]"></td>
                  </tr>
                  <tr>
                    <td>Provisional Obra</td>
                    <td><input type="text" v-model="valoresTiposCarga.provisionalObra[0]"></td>
                    <td><input type="text" v-model="valoresTiposCarga.provisionalObra[1]"></td>
                    <td><input type="text" v-model="valoresTiposCarga.provisionalObra[2]"></td>
                  </tr>
                  <tr>
                    <td>Otro</td>
                    <td><input type="text" v-model="valoresTiposCarga.otro[0]"></td>
                    <td><input type="text" v-model="valoresTiposCarga.otro[1]"></td>
                    <td><input type="text" v-model="valoresTiposCarga.otro[2]"></td>
                  </tr>
                </tbody>
              </table>
            </div>

          <div v-if="formData.conectionType == 'Compleja'" class="mb-3">
            <div>
              <label>Fecha estimada de entrada en operación</label>
              <datepicker v-model="formData.dateInicioOperacion"></datepicker>
            </div>
          </div> 
          
          <div v-if="formData.serviceDetail.basicDataConexionPoint == '1'">
            <div class="row mb-3">
              <div class="col">
                <label>Número de usuarios</label>
                <input type="text" @keypress="onlyNumber" v-model="formData.serviceDetail.numbeUsers">
              </div>
              <div class="col">
                <label>Carga total solicitada (kVA)</label>
                <input type="text" @keypress="onlyNumber" v-model="formData.serviceDetail.capacityTransformerInstall">
              </div>
            </div>
            <div class="row">
              <div class="col">
                <label>Tipo de subestación</label>
                <select name="socioeconomic" id="requestedService" v-model="formData.serviceDetail.substationType">
                  <option value="Exterior">Exterior</option>
                  <option value="Interior">Interior</option>
                </select>
              </div>
              <div class="col">
                <label for="">Nodo de referencia</label>
                <input type="text" @keypress="onlyNumber" maxlength="7" v-model="formData.serviceDetail.nodoReference">
              </div>
            </div>
          </div>
          <div v-if="formData.serviceDetail.basicDataConexionPoint == '2'">
            <div class="row mb-3">
              <div class="col">
                <label>Número de contrato</label>
                <input type="text" @keypress="onlyNumber" v-model="formData.serviceDetail.contractNumber">
              </div>
              <div class="col">
                <label  style="width: 100%;" for="">Número de transformador actual</label>
                  <select style="width: 20%;" v-model="formData.serviceDetail.transformerType">
                    <option value="PP">PP</option>
                    <option value="E">E</option>
                  </select>                     
                  <input style="width: 80%;" type="text" @keypress="onlyNumber" v-model="formData.serviceDetail.transformerNumber">            
              </div>
            </div>
            <div class="row">
              <div class="col">
                <label for="">Nodo</label>
                <input type="text" @keypress="onlyNumber" maxlength="7" v-model="formData.serviceDetail.nodo">
              </div>
              <div class="col">
                <label for="">Capacidad de transformador (kVA)</label>
                <input type="text" @keypress="onlyNumber" v-model="formData.serviceDetail.capacityTransformer">
              </div>
            </div>
            <div class="my-3">
              <label for="name">¿Se retira transformador?</label>
              <div class="d-flex align-items-center">
                <div class="radio">
                  <input :checked="formData.serviceDetail.transformerRecall == 1" @click="formData.serviceDetail.transformerRecall = 1" id="transformerRecallTrue" name="radio-person-type" type="radio">
                  <label for="transformerRecallTrue" class="radio-label">Si</label>
                </div>
                <div class="radio">
                  <input :checked="formData.serviceDetail.transformerRecall == 0" @click="formData.serviceDetail.transformerRecall = 0" id="transformerRecallFalse" name="radio-person-type" type="radio">
                  <label for="transformerRecallFalse" class="radio-label">No</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <label>Tipo de subestación</label>
                <select name="socioeconomic" v-model="formData.serviceDetail.substationType">
                  <option value="Exterior">Exterior</option>
                  <option value="Interior">Interior</option>
                </select>
              </div>
              <div class="col">
                <label>Carga total solicitada (kVA)</label>
                <input type="text" @keypress="onlyNumber" v-model="formData.serviceDetail.capacityTransformerInstall">
              </div>
            </div>
          </div>
          <div v-if="formData.serviceDetail.basicDataConexionPoint == '10'">
            <div class="row mb-3">
              <div class="col">
                <label>Número de contrato</label>
                <input type="text" @keypress="onlyNumber" v-model="formData.serviceDetail.contractNumber">
              </div>
              <div class="col">
                <label  style="width: 100%;" for="">Número de transformador actual</label>
                  <select style="width: 20%;" v-model="formData.serviceDetail.transformerType">
                    <option value="PP">PP</option>
                    <option value="E">E</option>
                  </select>                     
                  <input style="width: 80%;" type="text" @keypress="onlyNumber" v-model="formData.serviceDetail.transformerNumber">            
              </div>
            </div>
            <div class="row">
              <div class="col">
                <label for="">Nodo</label>
                <input type="text" @keypress="onlyNumber" maxlength="7" v-model="formData.serviceDetail.nodo">
              </div>
              <div class="col">
                <label for="">Capacidad de transformador (kVA)</label>
                <input type="text" @keypress="onlyNumber" v-model="formData.serviceDetail.capacityTransformer">
              </div>
            </div>
            <div class="my-3">
              <label for="name">¿Se retira transformador?</label>
              <div class="d-flex align-items-center">
                <div class="radio">
                  <input :checked="formData.serviceDetail.transformerRecall == 1" @click="formData.serviceDetail.transformerRecall = 1" id="transformerRecallTrue" name="radio-person-type" type="radio">
                  <label for="transformerRecallTrue" class="radio-label">Si</label>
                </div>
                <div class="radio">
                  <input :checked="formData.serviceDetail.transformerRecall == 0" @click="formData.serviceDetail.transformerRecall = 0" id="transformerRecallFalse" name="radio-person-type" type="radio">
                  <label for="transformerRecallFalse" class="radio-label">No</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <label>Tipo de subestación</label>
                <select name="socioeconomic" v-model="formData.serviceDetail.substationType">
                  <option value="Exterior">Exterior</option>
                  <option value="Interior">Interior</option>
                </select>
              </div>
              <div class="col">
                <label>Carga total solicitada (kVA)</label>
                <input type="text" @keypress="onlyNumber" v-model="formData.serviceDetail.capacityTransformerInstall">
              </div>
            </div>
          </div>
          <div v-if="formData.serviceDetail.basicDataConexionPoint == '3'">
            <div class="row">
              <div class="col">
                <label>Carga total solicitada (kVA)</label>
                <input type="text" @keypress="onlyNumber" v-model="formData.serviceDetail.capacityTransformerInstall">
              </div>
              <div class="col">
                <label>Tipo de subestación</label>
                <select v-model="formData.serviceDetail.substationType">
                  <option value="Exterior">Exterior</option>
                  <option value="Interior">Interior</option>
                </select>
              </div>
              <div class="col">
                <label for="nodoReference">Nodo de referencia</label>
                <input type="text" @keypress="onlyNumber" maxlength="7" id="nodoReference" v-model="formData.serviceDetail.nodoReference">
              </div>
            </div>
          </div>
          <div v-if="formData.serviceDetail.basicDataConexionPoint == '4'">
            <div class="row">
              <div class="col">
                <label for="">Número o datos solicitud anterior</label>
                <input type="text" @keypress="onlyNumber" v-model="formData.serviceDetail.documentModify">
              </div>
            </div>
          </div>
          <div v-if="formData.serviceDetail.basicDataConexionPoint == '5'">
            <div class="row mb-3">
              <div class="col">
                <label  style="width: 100%;"  for="">Número de transformador</label>                
                  <select style="width: 20%;" v-model="formData.serviceDetail.transformerType">
                    <option value="PP">PP</option>
                    <option value="E">E</option>
                  </select> 
                  <input style="width: 80%;" type="text" @keypress="onlyNumber" v-model="formData.serviceDetail.transformerNumber">   
              </div>
              <div class="col">
                <label for="kVRequiered">Nivel de tensión requerido</label>
                <select id="kVRequiered" v-model="formData.serviceDetail.kvRequiered">
                  <option value="2">Tensión mayor o igual a 1 kV y menor a 30 kV</option>
                  <option value="3">Tensión mayor o igual a 30 kV y menor a 57.5 kV</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <label for="">Nodo</label>
                <input type="text" maxlength="7" @keypress="onlyNumber" v-model="formData.serviceDetail.nodo">
              </div>
              <div class="col">
                <label for="">Capacidad de transformador (kVA)</label>
                <input type="text" @keypress="onlyNumber" v-model="formData.serviceDetail.capacityTransformer">
              </div>
            </div>
          </div>
          <div v-if="formData.serviceDetail.basicDataConexionPoint == '6'">
            <div class="row">
              <div class="col">
                <label  style="width: 100%;" for="">Número de transformador</label>                 
                  <select style="width: 20%;" v-model="formData.serviceDetail.transformerType">
                    <option value="PP">PP</option>
                    <option value="E">E</option>
                  </select>  
                  <input style="width: 80%;" type="text" @keypress="onlyNumber" v-model="formData.serviceDetail.transformerNumber"> 
              </div>
              <div class="col">
                <label for="">Nodo</label>
                <input type="text" @keypress="onlyNumber" maxlength="7" v-model="formData.serviceDetail.nodo">
              </div>
              <div class="col">
                <label for="">Capacidad de transformador (kVA)</label>
                <input type="text" @keypress="onlyNumber" v-model="formData.serviceDetail.capacityTransformer">
              </div>
            </div>
          </div>
          <div v-if="formData.serviceDetail.basicDataConexionPoint == '7'">
            <div class="row mb-3">
              <div class="col">
                <label for="">Nodo referencia 1</label>
                <input type="text" @keypress="onlyNumber" maxlength="7" v-model="formData.serviceDetail.nodoReference1">
              </div>
              <div class="col">
                <label for="">Nodo referencia 2</label>
                <input type="text" @keypress="onlyNumber" maxlength="7" v-model="formData.serviceDetail.nodoReference2">
              </div>
            </div>
            <div>
              <label for="">Tramo de la red a intervenir</label>
              <input type="text" v-model="formData.serviceDetail.sectionNetwork">
            </div>
          </div>
          <div v-if="formData.serviceDetail.basicDataConexionPoint == '8'">
            <div class="row mb-3">
              <div class="col">
                <label>Número de luminarias</label>
                <input type="text" @keypress="onlyNumber" v-model="formData.serviceDetail.numbeUsers">
              </div>
              <div class="col">
                <label>Carga total solicitada (kVA)</label>
                <input type="text" @keypress="onlyNumber" v-model="formData.serviceDetail.capacityTransformerInstall">
              </div>
            </div>
            <div class="row">
              <div class="col">
                <label>Tipo de subestación</label>
                <select name="socioeconomic" id="requestedService" v-model="formData.serviceDetail.substationType">
                  <option value="Exterior">Exterior</option>
                  <option value="Interior">Interior</option>
                </select>
              </div>
              <div class="col">
                <label for="">Nodo de referencia</label>
                <input type="text" maxlength="7" @keypress="onlyNumber" v-model="formData.serviceDetail.nodoReference">
              </div>
            </div>
          </div>
          <div v-if="formData.serviceDetail.basicDataConexionPoint == '9'">
            <div class="row mb-3">
              <div class="col">
                <label>Número de luminarias</label>
                <input type="text" @keypress="onlyNumber" v-model="formData.serviceDetail.numbeUsers">
              </div>
              <div class="col">
                <label>Carga total solicitada (kVA)</label>
                <input type="text" @keypress="onlyNumber" v-model="formData.serviceDetail.capacityTransformerInstall">
              </div>
            </div>
            <div class="row">
              <div class="col">
                <label>Tipo de subestación existente</label>
                <select name="socioeconomic" id="requestedService" v-model="formData.serviceDetail.substationType">
                  <option value="Exterior">Exterior</option>
                  <option value="Interior">Interior</option>
                </select>
              </div>
              <div class="col">
                <label for="">Nodo de referencia</label>
                <input type="text" maxlength="7" @keypress="onlyNumber" v-model="formData.serviceDetail.nodoReference">
              </div>
            </div>
          </div>
          <div v-if="formData.conectionType == 'Simple'" class="mt-3">
            <h3>Carga kVA</h3>
            <div class="row mb-3">
              <div class="col">
                <label for="">Requerida</label>
                <input type="text" v-model="formData.serviceDetail.chargeRequired">
              </div>
              <div class="col">
                <label for="">Existente</label>
                <input type="text" v-model="formData.serviceDetail.chargeExistent">
              </div>
            </div>
            <div>
              <label for="name">¿El proyecto incluye algún sistema de generación?</label>
              <div class="d-flex align-items-center">
                <div class="radio">
                  <input :checked="formData.serviceDetail.generationSistem == 1" @click="formData.serviceDetail.generationSistem = 1" id="transformerRecallTrue" name="radio-person-type" type="radio">
                  <label for="transformerRecallTrue" class="radio-label">Si</label>
                </div>
                <div class="radio">
                  <input :checked="formData.serviceDetail.generationSistem == 0" @click="formData.serviceDetail.generationSistem = 0" id="transformerRecallFalse" name="radio-person-type" type="radio">
                  <label for="transformerRecallFalse" class="radio-label">No</label>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-3">
            <button @click="validateStep7()" class="app-btn px-4 ml-auto">Continuar</button>
          </div>
        </div>
      </div>

      <div v-if="step == 8" class="form-container text-left">
        <div class="d-flex justify-content-between mb-3">
            <span>
              <img src="https://img.icons8.com/material/24/000000/calendar--v1.png"/>
              Fecha de solicitud: {{date.toLocaleDateString("es-Es", options)}}
            </span>
            <div class="d-flex">
                <div class="application-number mr-2">
                  Solicitud - <span v-if="formData.conectionType == 'Simple'">UPB</span> <span v-if="formData.conectionType == 'Compleja'">UPM</span> <span v-if="formData.conectionType == 'Certificado'">CERTIFICADO</span>
                </div>
            </div>
        </div>
        <div>
          <h2 class="bold">Observaciones generales de la solicitud.</h2>
          <p v-if="formData.serviceDetail.basicDataConexionPoint != '9'">Información adicional pertinente a la construcción del proyecto.</p>
          <p v-if="formData.serviceDetail.basicDataConexionPoint == '9'">Información adicional Indicando transformador y el nodo donde se va a adicionar las luminarias.</p>
          
          <div class="input-wrap">
            <textarea v-model="formData.observations" cols="30" rows="10"></textarea>
          </div>

          
          <div class="mt-3">
            <label class="file">Anexar información al punto de conexión <v-icon class="ml-2" name="upload" scale="1.5"/>
              <input @change="onFiledocumentPointConection($event)" type="file" >
              <div class="file-selected" v-if="formData.applicantInfo.documentPointConection">
                {{formData.applicantInfo.documentPointConectionFile.name}} - 
                <button type="button" class="close" @click="confirmeddocumentPointConection = true; validarInputdocumentPointConection()">
                <span><v-icon class="ml-1" name="trash" scale="1.5"/></span>
              </button>
              </div>
            </label> 
          </div>

          <div class="mt-3">
            <button @click="createRequest()" class="app-btn px-4 ml-auto">Finalizar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Error Modal -->
    <div v-if="error != ''" class="error-modal">
      <div @click="error = ''" class="backdrop"></div>
      <div class="modal-box">
        <div class="app-icon mb-2">
          <v-icon name="exclamation-triangle" scale="2"/>
        </div>
        <div class="mb-4">
          {{error}}
        </div>
        <div>
          <button @click="error = ''" class="app-btn w-100">Continuar</button>
        </div>
      </div>
    </div>

    <!-- Error Modal -->
    <div v-if="privacyInfo" class="privacy-modal">
      <div class="backdrop"></div>
      <div class="modal-box">
        <div class="mb-4">
          <h2>Protección Datos Personales</h2>
          <h3>AVISO DE PRIVACIDAD</h3>
          <p>El presente Aviso de Privacidad (en adelante el “Aviso”) establece los términos y condiciones en virtud de los cuales EMCALI EICE ESP, identificado con NIT 890.399.003-4 y con domicilio principal en el Centro Administrativo Municipal-CAM TORRE EMCALI piso 3° de Cali, realizará el tratamiento de sus datos personales.</p>
          <h4>1. TRATAMIENTO Y FINALIDAD:</h4>
          <p>El tratamiento que realizará EMCALI EICE ESP con la información personal será el siguiente:<br>
La recolección, almacenamiento, uso, circulación respecto de la información personal recolectada será utilizada para,</p>
          <ol>
            <li>Efectuar las gestiones pertinentes para el desarrollo del objeto social de EMCALI EICE ESP en lo que tiene que ver con el cumplimiento del objeto del contrato celebrado con el Titular de la información.</li>
            <li>Realizar invitaciones a eventos y ofrecer nuevos productos y servicios.</li>
            <li>Gestionar trámites (solicitudes, quejas, reclamos, ventas e instalación servicio, gestión comercial, operativa y de cobro).</li>
            <li>Efectuar encuestas de satisfacción respecto de los bienes y servicios ofrecidos por EMCALI EICE ESP.</li>
            <li>Suministrar información de contacto a la fuerza comercial y/o red de distribución, telemercadeo, investigación de mercados y cualquier tercero con el cual EMCALI EICE ESP tenga un vínculo contractual para el desarrollo de actividades de ese tipo (investigación de mercados y telemercadeo, entre otros ) para la ejecución de las mismas.</li>
            <li>Contactar al Titular a través de medios telefónicos para realizar encuestas, estudios y/o confirmación de datos personales necesarios para la ejecución de una relación contractual y gestión administrativa.</li>
            <li>Contactar al Titular a través de medios electrónicos – SMS o chat para el envío de noticias relacionadas con campañas de fidelización o mejora del servicio.</li>
            <li>Contactar al Titular a través de correo electrónico para el envío de extractos, estados de cuenta o facturas en relación con las obligaciones derivadas del contrato celebrado entre las partes.</li>
            <li>Dar cumplimiento a las obligaciones contraídas por EMCALI EICE ESP con el Titular de la Información, con relación al pago de salarios, prestaciones sociales y demás retribuciones consagradas en el contrato de trabajo o según lo disponga la ley.</li>
            <li>Ofrecer programas de bienestar corporativo y planificar actividades empresariales, para el titular y sus beneficiarios.</li>
            <li>Transferir datos personales para cumplir con las regulaciones anti lavado de activos que le aplican.</li>
            <li>Transmitir los datos personales fuera del país a terceros con los cuales EMCALI EICE ESP haya suscrito un contrato de procesamiento de datos y sea necesario entregársela para el cumplimiento del objeto contractual.</li>
            <li>Prestar los servicios ofrecidos por EMCALI EICE ESP y aceptados en el contrato suscrito.</li>
            <li>Suministrar la información a terceros con los cuales EMCALI EICE ESP tenga relación contractual y que sea necesario entregársela para el cumplimiento del objeto contratado.</li>
            <li>Tramitar solicitudes o cualquier tipo de petición que sea realizada por el usuario, a través de cualquiera de las formas de contacto que se ponen a disposición del usuario como son: Centros de Atención al Cliente CAP´s y Centro de Atención Local Integrada CALI´s, la línea de atención gratuita Contact Center 177 o (2) 5240177, y la página web <a target="_blank" href="http://www.emcali.com.co">www.emcali.com.co</a></li>
          </ol>
          <h4>2. DERECHOS DEL TITULAR:</h4>
          <p>Como titular de sus datos personales Usted tiene derecho a:</p>
          <ol type = "i">
            <li>Acceder en forma gratuita a los datos proporcionados que hayan sido objeto de tratamiento.</li>
            <li>Conocer, actualizar y rectificar su información frente a datos parciales, inexactos, incompletos, fraccionados, que induzcan a error, o a aquellos cuyo tratamiento esté prohibido o no haya sido autorizado.</li>
            <li>Solicitar prueba de la autorización otorgada.</li>
            <li>Presentar ante la Superintendencia de Industria y Comercio (SIC) quejas por infracciones a lo dispuesto en la normatividad vigente.</li>
            <li>Revocar la autorización y/o solicitar la supresión del dato, siempre que no exista un deber legal o contractual que impida eliminarlos.</li>
            <li>Abstenerse de responder las preguntas sobre datos sensibles.</li>
          </ol>
          <p>Tendrá carácter facultativo las respuestas que versen sobre datos sensibles o sobre datos de las niñas y niños y adolescentes.</p>
            <h4>MECANISMOS PARA CONOCER LA POLÍTICA DE TRATAMIENTO</h4>
            <p>El Titular puede acceder a nuestra Política de Tratamiento de información, la cual se encuentra publicada en <a target="_blank" href="http://www.emcali.com.co">www.emcali.com.co</a></p>
        </div>
        <div>
          <button @click="privacyInfo = false; questionVoltageWarn = true; questionVoltage()" class="app-btn w-100">Acepto</button>
        </div>
      </div>
    </div>

    <div v-if="confirmedDoc == false" class="error-modal">
      <div @click="confirmAcceptDoc = false" class="backdrop"></div>
      <div class="modal-box">
          <div class="d-flex justify-content-center app-icon mb-2">
            <v-icon name="exclamation-triangle" scale="2"/>
          </div>
          <div class="mb-4">
            ¿Esta seguro de borrar el documento?
          </div>
          <div class="d-flex justify-content-center mb-6">
          <div class=" px-4 mr-3">
            <button @click="confirmAcceptDoc = true; confirmedDoc = true; borrarDocumentoIdentidad()" class="app-btn app-btn--blue">Si</button>
          </div>
          <div class=" px-4 mr-3 ">
            <button @click="confirmAcceptDoc = false; confirmedDoc = true" class="app-btn app-btn">No</button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="confirmedAuth == false" class="error-modal">
      <div @click="confirmAcceptDocAuth = false" class="backdrop"></div>
      <div class="modal-box">
          <div class="d-flex justify-content-center app-icon mb-2">
            <v-icon name="exclamation-triangle" scale="2"/>
          </div>
          <div class="mb-4">
            ¿Esta seguro de borrar el documento?
          </div>
          <div class="d-flex justify-content-center mb-6">
          <div class=" px-4 mr-3">
            <button @click="confirmAcceptDocAuth = true; confirmedAuth = true; borrarDocumentoAuth()" class="app-btn app-btn--blue">Si</button>
          </div>
          <div class=" px-4 mr-3 ">
            <button @click="confirmAcceptDocAuth = false; confirmedAuth = true" class="app-btn app-btn">No</button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="confirmedCamara == false" class="error-modal">
      <div @click="confirmAcceptDocCamara = false" class="backdrop"></div>
      <div class="modal-box">
          <div class="d-flex justify-content-center app-icon mb-2">
            <v-icon name="exclamation-triangle" scale="2"/>
          </div>
          <div class="mb-4">
            ¿Esta seguro de borrar el documento?
          </div>
          <div class="d-flex justify-content-center mb-6">
          <div class=" px-4 mr-3">
            <button @click="confirmAcceptDocCamara = true; confirmedCamara = true; borrarDocumentoCamara()" class="app-btn app-btn--blue">Si</button>
          </div>
          <div class=" px-4 mr-3 ">
            <button @click="confirmAcceptDocCamara = false; confirmedCamara = true" class="app-btn app-btn">No</button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="confirmeddocumentPointConection == false" class="error-modal">
      <div @click="confirmAcceptdocumentPointConection = false" class="backdrop"></div>
      <div class="modal-box">
          <div class="d-flex justify-content-center app-icon mb-2">
            <v-icon name="exclamation-triangle" scale="2"/>
          </div>
          <div class="mb-4">
            ¿Esta seguro de borrar el documento?
          </div>
          <div class="d-flex justify-content-center mb-6">
          <div class=" px-4 mr-3">
            <button @click="confirmAcceptdocumentPointConection = true; confirmeddocumentPointConection = true; borrardocumentPointConection()" class="app-btn app-btn--blue">Si</button>
          </div>
          <div class=" px-4 mr-3 ">
            <button @click="confirmAcceptdocumentPointConection = false; confirmeddocumentPointConection = true" class="app-btn app-btn">No</button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="questionVoltageWarn == false" class="error-modal">
      <div @click="questionVoltageAcceptWarn = false" class="backdrop"></div>
      <div class="modal-box">
          <div class="d-flex justify-content-center app-icon mb-2">
            <v-icon name="exclamation-triangle" scale="2"/>
          </div>
          <div class="mb-4">
            Si su conexi&oacute;n es menor a 30kVA, la solicitud debe gestionarse en el centro de atenci&oacute;n. Clic para descargar formulario. 
          </div>
          <div class="mb-4">
            <a href="https://www.emcali.com.co/documents/20143/1298396/Solicitud+Servicio+Publico+Energia.pdf" style="width: 100%;" target="_blank">DESCARGAR FORMULARIO</a>
          </div>
          <div class="d-flex justify-content-center mb-6">
            <div class=" px-4 mr-3">
            <button @click="questionVoltageAcceptWarn = true; questionVoltageWarn = true; indicationsRequest = true; indicationsRequestWarn()" class="app-btn" style="width: 90%;">Gestionar en centro de atenci&oacute;n</button>
          </div>
          <div class=" px-4 mr-3 ">
            <button @click="questionVoltageAcceptWarn = false; questionVoltageWarn = true" class="app-btn app-btn--blue" style="width: 100%;">Continuar</button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="indicationsRequest == false" class="error-modal">
      <div @click="indicationsRequestAccept = false" class="backdrop"></div>
      <div class="modal-box">
          <div class="d-flex justify-content-center app-icon mb-2">
            <v-icon name="exclamation-triangle" scale="2"/>
          </div>
          <div class="mb-4">
            Su solicitud se tramitar&aacute; en un Centro de Atenci&oacute;n de Emcali
          </div>
          <div class="d-flex justify-content-center mb-6">
          <div class=" px-4 mr-3">
            <a href="https://www.emcali.com.co/web/energia/circular075">            
              <button @click="indicationsRequestAccept = true; indicationsRequest = true; redireccionar()" class="app-btn app-btn--blue">ACEPTAR</button>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Screen Loader -->
    <div v-if="loading" class="screen-loader">
      <div class="spinner">
        <v-icon name="circle-notch" scale="3"/>
      </div>
    </div>

  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import Datepicker from 'vuejs-datepicker';

export default {
  name: 'Form',
  components: {
    Datepicker
  },
  data(){
    return {  
      step: 1,
      date: new Date(),
      options: { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' },
      error: '',
      confirmedDoc: true,
      confirmAcceptDoc: false,
      confirmedCamara: true,
      confirmAcceptDocCamara: false,
      confirmeddocumentPointConection: true,
      confirmAcceptdocumentPointConection: false,
      confirmedAuth: true,
      confirmAcceptDocAuth: false,
      questionVoltageWarn: true,
      questionVoltageAcceptWarn: false,
      indicationsRequest: true,
      privacyInfo: true,
      loading: false,
      applicantAddress: '',
      applicantInfo: '',
      resultSubscriptorAddress: '',
      resultEstateAddress: '',
      electricInfrastructure: '',
      estateInfo: '',
      serviceDetail: '',
      subscriptorInfo: '',
      tiposCarga: ['residencial','comercial','industrial','oficial','alumbradoPublico', 'provisionalObra','otro'],
      valoresTiposCarga:{
        residencial: [0,0,0],
        comercial: [0,0,0],
        industrial: [0,0,0],
        oficial:  [0,0,0],
        alumbradoPublico:  [0,0,0],
        provisionalObra: [0,0,0],
        otro: [0,0,0],
        totalPorCarga:[0,0,0],
        total: 0
      },
      formData: {
        proyectName: '',
        confirmedDoc: true,
        confirmAcceptDoc: false,
        confirmedCamara: true,
        confirmAcceptDocCamara: false,
        confirmAcceptdocumentPointConection: false,
        confirmeddocumentPointConection: true,
        questionVoltageWarn: true,
        questionVoltageAcceptWarn: false,
        indicationsRequest: true,
        conectionType: '',
        dateInicioOperacion: '',
        idRequest: 0,
        applicantInfo: {
          name: '',
          personType: 'Natural',
          juridicType: 'Ninguno',
          documentType: '',
          documentNumber: '',
          address: {
            streetType: '',
            road1: '',
            road1Direction: '',
            road2: '',
            road2Direction: '',
            streetNumber: '',
            description: ''
          },
          commune: '',
          municipality: '',
          department: '',
          celphoneNumber: '',
          phone: '',
          email: '',
          mailNotificationsAuth: 1,
          solicitantSameSubscriptor: 1,
          idDocumentCopy: null,
          idDocumentCopyFile: '',
          idDocumentCopyName: '',
          naturalPersonOrRepresentantId: null,
          idCard: '',
          authLetter: null,
          authLetterFile: '',
          authLetterName: '',
          camaraComercio: null,
          camaraComercioFile: '',
          camaraComercioName: '',
          documentPointConection: null,
          documentPointConectionFile: '',
          documentPointConectionName: ''
        },
        subscriptorInfo: {
          name: '',
          personType: 'Natural',
          juridicType: 'Ninguno',
          documentType: '',
          documentNumber: '',
          address: {
            streetType: '',
            road1: '',
            road1Direction: '',
            road2: '',
            road2Direction: '',
            streetNumber: '',
            description: ''
          },
          commune: '',
          municipality: '',
          department: '',
          celphoneNumber: '',
          phone: '',
          email: '',
          mailNotificationsAuth: 1,
          idDocumentCopy: null,
          idDocumentCopyFile: '',
          idDocumentCopyName: '',
          naturalPersonOrRepresentantId: null,
          camaraComercio: null,
          camaraComercioFile: '',
          camaraComercioName: ''
        },
        estateInfo: {
          zoneType: null,
          nieAccountNumber: '',
          latitud: '',
          longitud: '',
          height: '',
          indications: '',
          predioNumber: '',
          address: {
            description: '',
            road1: '',
            road1Direction: '',
            road2: '',
            road2Direction: '',
            streetNumber: '',
            streetType: '',
          },
          commune: '',
          municipality: '',
          department: '',
          existentEstate: 1,
          estateInfoCert: null,
          estateInfoCertFile: '',
          estateInfoCertName: '',
          urbanLicence: null,
          contructionLicence: null
        },
        typesOfUseAndEconomicActivity: {
          typeUse: '',
          residencialType: 'Lotes',
          socioEconomic: '',
          economicActivity: 1
        },
        electricInfrastructure: {
          closeElectricRed: null,
          redDistance: '',
          transformerNumber: ''
        },
        serviceDetail: {
          chargeRequired: '',
          chargeExistent: '',
          nodo: '',
          requestedService: '',
          areaMt2: '',
          realStateRegistration: '',
          numbeUsers: 0,
          nodoReference: '',
          capacityKvaSolicited: '',
          activitiesSchedule: '',
          basicDataConexionPoint: '',
          capacityTransformer: '',
          capacityTransformerInstall: '',
          substationType: 'Exterior',
          transformerNumber: '',
          transformerType: '',
          transformerRecall: 0,
          activitySchedule: '',
          contractNumber: '',
          documentModify: '',
          tensionRequiere: '13.2kV',
          nodoReference1: '',
          nodoReference2: '',
          sectionNetwork: '',
          kvRequiered: 1,
          tensionRequested: '',
          generationSistem: 0
        },
        observations: ''
      },
    }
  },
  mounted(){
    window.onbeforeunload = function(){
      return '¿Estas seguro? Esto eliminará la información';
    };
  },
  methods:{
    borrarDocumentoIdentidad(){
      this.formData.applicantInfo.idDocumentCopy = null;     
    },
    borrarDocumentoCamara(){
      this.formData.applicantInfo.camaraComercio = null;     
    },
    borrardocumentPointConection(){
      this.formData.applicantInfo.documentPointConection = null;    
      this.formData.applicantInfo.documentPointConectionNamen = '';     
    },
    borrarDocumentoAuth(){
      this.formData.applicantInfo.authLetter = null;     
    },
    validarInputDocument(){
      this.confirmedDoc = false;
        return;        
    },
    validarInputDocumentCamara(){
      this.confirmedCamara = false;
        return;        
    },
    validarInputdocumentPointConection(){
      this.confirmeddocumentPointConection = false;
        return;        
    },
    validarInputDocumentAuth(){
      this.confirmedAuth = false;
        return;        
    },    
    redireccionar(){    
      window.onbeforeunload=null;  
      return;
    },
    questionVoltage(){
      this.questionVoltageWarn = false;
      return;        
    },
    indicationsRequestWarn(){
      this.indicationsRequest = false;
        return;        
    },
    onlyNumber ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
          $event.preventDefault();
      }
    },
    backStep(){
      if ((this.step == 5 && this.formData.applicantInfo.solicitantSameSubscriptor == 1) || (this.step == 8 && (this.formData.serviceDetail.basicDataConexionPoint == 2 || this.formData.serviceDetail.basicDataConexionPoint == 5 || this.formData.serviceDetail.basicDataConexionPoint == 6))) {
        this.step --;
        this.step --;
      }else{
        this.step --;
      }
    },
    validateStep1(){
      if (this.formData.proyectName == '') {
        this.error = 'El proyecto debe tener un nombre';
        return;
      }

      this.nextStep();
    },
    validateStep2(){

      // Validations
      if (this.formData.applicantInfo.name == '') {
        this.error = 'Llene el nombre o razón social del solicitante';
        return;
      }
      if (this.formData.applicantInfo.personType == '') {
        this.error = 'Seleccione el tipo de persona';
        return;
      }
      if (this.formData.applicantInfo.personType == 'Juridica' && this.formData.applicantInfo.juridicType == 'Ninguno') {
        this.error = 'Seleccione el tipo de persona jurídica';
        return;
      }
      if (this.formData.applicantInfo.documentType == '') {
        this.error = 'Seleccione el tipo de documento';
        return;
      }
      if (this.formData.applicantInfo.documentNumber == '') {
        this.error = 'Llene el número de documento';
        return;
      }
      if (this.formData.applicantInfo.commune == '') {
        this.error = 'Si no sabe el número de su comuna coloque 0';
        return;
      }
      if (this.formData.applicantInfo.department == '') {
        this.error = 'Departamento';
        return;
      }
      if (this.formData.applicantInfo.municipality == '') {
        this.error = 'Municipio';
        return;
      }


      if (this.formData.applicantInfo.email == '') {
        this.error = 'Escriba su email';
        return;
      }
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.formData.applicantInfo.email)) {
          // Good email
      } else {
          this.error = 'Escriba un email válido';
          return;
      }
      if (this.formData.applicantInfo.emailConfirm == '') {
        this.error = 'Por favor confirme su email';
        return;
      }
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.formData.applicantInfo.emailConfirm)) {
          // Good email
      } else {
          this.error = 'Email de confirmación no válido';
          return;
      }
      if (this.formData.applicantInfo.email !== this.formData.applicantInfo.emailConfirm) {
        this.error = 'Los email ingresados no coinciden';
        return;
      }

      
      if (this.formData.applicantInfo.celphoneNumber == '') {
        this.error = 'Escriba su número celular';
        return;
      }
      if (this.formData.applicantInfo.celphoneNumberConfirm == '') {
        this.error = 'Confirme su número celular';
        return;
      }
      if (this.formData.applicantInfo.celphoneNumber !== this.formData.applicantInfo.celphoneNumberConfirm) {
        this.error = 'Los números de celular no coinciden';
        return;
      }


      if (this.formData.applicantInfo.celphoneNumber.length < 10) {
        this.error = 'Revise su número de celular, debe tener 10 números';
        return;
      }
      if (this.formData.applicantInfo.phone == '') {
        this.error = 'Escriba su número de teléfono fijo';
        return;
      }

      if (this.formData.applicantInfo.phone.length < 10) {
        this.error = 'El número de teléfono fijo debe tener el indicativo por departamento';
        return;
      }      
      
      if (this.formData.applicantInfo.address.streetType == '') {
        this.error = 'Seleccione el tipo de vía de la dirección de correspondencia';
        return;
      }
      if (this.formData.applicantInfo.address.road1 == '') {
        this.error = 'Digite la vía principal de la dirección de correspondencia';
        return;
      }
      if (this.formData.applicantInfo.address.road1Direction == '') {
        this.error = 'Seleccione la orientación de la vía principal';
        return;
      }
      if (this.formData.applicantInfo.address.road2 == '') {
        this.error = 'Digite la vía secundaria de la dirección de correspondencia';
        return;
      }
      if (this.formData.applicantInfo.address.road2Direction == '') {
        this.error = 'Seleccione la orientación de la vía secundaria';
        return;
      }
      if (this.formData.applicantInfo.address.streetNumber == '') {
        this.error = 'Digite el número de la calle';
        return;
      }
      
      if(this.formData.applicantInfo.solicitantSameSubscriptor){

        this.step ++;
        this.step ++;
        window.scrollTo(0, 0);
        
        // Subscriptor same info
        this.formData.subscriptorInfo.name = this.formData.applicantInfo.name,
        this.formData.subscriptorInfo.personType = this.formData.applicantInfo.personType,
        this.formData.subscriptorInfo.juridicType = this.formData.applicantInfo.juridicType,
        this.formData.subscriptorInfo.documentType = this.formData.applicantInfo.documentType,
        this.formData.subscriptorInfo.documentNumber = this.formData.applicantInfo.documentNumber,
        this.formData.subscriptorInfo.commune = this.formData.applicantInfo.commune,
        this.formData.subscriptorInfo.municipality = this.formData.applicantInfo.municipality,
        this.formData.subscriptorInfo.department = this.formData.applicantInfo.department,
        this.formData.subscriptorInfo.celphoneNumber = this.formData.applicantInfo.celphoneNumber,
        this.formData.subscriptorInfo.phone = this.formData.applicantInfo.phone,
        this.formData.subscriptorInfo.email = this.formData.applicantInfo.email,
        this.formData.subscriptorInfo.mailNotificationsAuth = this.formData.applicantInfo.mailNotificationsAuth,
        this.formData.subscriptorInfo.camaraComercio = this.formData.applicantInfo.camaraComercio,
        this.formData.subscriptorInfo.idDocumentCopy = this.formData.applicantInfo.idDocumentCopy,
        this.formData.subscriptorInfo.idDocumentCopyFile = this.formData.applicantInfo.idDocumentCopyFile,
        this.formData.subscriptorInfo.idDocumentCopyName = this.formData.applicantInfo.idDocumentCopyName,
        this.formData.subscriptorInfo.naturalPersonOrRepresentantId = this.formData.applicantInfo.naturalPersonOrRepresentantId,
        this.formData.subscriptorInfo.address = this.formData.applicantInfo.address

      }else{
        this.step ++;
        window.scrollTo(0, 0);
      }

      if(this.formData.serviceDetail.documentModify != ""){
        this.getEstateInfo();
        this.updateApplicantInto();
      }
    },
    updateApplicantInto(){

      let dataSendAddress = {
        "id": this.formData.applicantInfo.address.id,
        "description": this.formData.applicantInfo.address.description,
        "road1": this.formData.applicantInfo.address.road1,
        "road1Direction": this.formData.applicantInfo.address.road1Direction,
        "road2": this.formData.applicantInfo.address.road2,
        "road2Direction": this.formData.applicantInfo.address.road2Direction,
        "streetNumber": this.formData.applicantInfo.address.streetNumber,
        "streetType": this.formData.applicantInfo.address.streetType,
        "createdDate": new Date(),
        "editedDate": new Date()
      };

      axios.post("address/update", dataSendAddress, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json' 
        }
      })
      .then((resultApplicantAddress) => {

        this.applicantAddress = resultApplicantAddress.data;
        
        let dataSendApplicant = {
          "id": this.formData.applicantInfo.id,
          "authLetter": this.formData.applicantInfo.authLetter,
          "documentLetterName": this.formData.applicantInfo.authLetterName,
          "celphoneNumber": this.formData.applicantInfo.celphoneNumber,
          "commune": this.formData.applicantInfo.commune,
          "department": this.formData.applicantInfo.department,
          "documentNumber": this.formData.applicantInfo.documentNumber,
          "documentType": this.formData.applicantInfo.documentType,
          "email": this.formData.applicantInfo.email,
          "idCard": this.formData.applicantInfo.idCard,
          "camaraComercio": this.formData.applicantInfo.camaraComercio,
          "documentPointConection": this.formData.applicantInfo.documentPointConection,
          "idDocumentCopy": this.formData.applicantInfo.idDocumentCopy,
          "idDocumentCopyFile": this.formData.applicantInfo.idDocumentCopyFile,
          "documentNameDocument": this.formData.applicantInfo.idDocumentCopyName,
          "juridicType": this.formData.applicantInfo.juridicType,
          "mailNotificationsAuth": this.formData.applicantInfo.mailNotificationsAuth,
          "municipality": this.formData.applicantInfo.municipality,
          "name": this.formData.applicantInfo.name,
          "naturalPersonRepresentantId": this.formData.applicantInfo.naturalPersonRepresentantId,
          "personType": this.formData.applicantInfo.personType,
          "phone": this.formData.applicantInfo.phone,
          "solicitantSameSubscriptor": this.formData.applicantInfo.solicitantSameSubscriptor,
          "address": this.applicantAddress,
          "createdDate": new Date(),
          "editedDate": new Date(),
          "idRequest": this.formData.applicantInfo.idRequest
        }

      axios.post("applicantInfo/update", dataSendApplicant, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then((result) => {
        console.log(result)
      })

      })
    },

    getEstateInfo(){
      axios.get("/request/" + this.formData.serviceDetail.documentModify)
      .then(responseIdReq => {

        if (responseIdReq.data.length != 0) { 
          axios.get("/estateInfo/" + responseIdReq.data.estateInfo.id)
          .then(response => {
            if (response.data.length != 0) { 
              this.formData.estateInfo.id = response.data.id
              this.formData.estateInfo.zoneType = response.data.zoneType
              this.formData.estateInfo.predioNumber = response.data.predioNumber
              this.formData.estateInfo.nieAccountNumber = response.data.nieAccountNumber
              this.formData.estateInfo.latitud = response.data.latitud
              this.formData.estateInfo.longitud = response.data.longitud
              this.formData.estateInfo.height = response.data.height
              this.formData.estateInfo.indications = response.data.indications  
              this.formData.estateInfo.address.id = response.data.address.id
              this.formData.estateInfo.address.streetType = response.data.address.streetType
              this.formData.estateInfo.address.description =response.data.address.description
              this.formData.estateInfo.address.road1 = response.data.address.road1
              this.formData.estateInfo.address.road1Direction = response.data.address.road1Direction
              this.formData.estateInfo.address.road2 = response.data.address.road2   
              this.formData.estateInfo.address.road2Direction = response.data.address.road2Direction
              this.formData.estateInfo.address.streetNumber = response.data.address.streetNumber
              this.formData.estateInfo.municipality = response.data.municipality
              this.formData.estateInfo.department = response.data.department    
              this.formData.estateInfo.commune = response.data.commune    
            }
            
            
            axios.get("/address/" + this.formData.estateInfo.address.id)
            .then(responseIdReq => {
              
            })
          })
        }
      })      
    },

    validateStep3(){

      // Validations
      if (this.formData.subscriptorInfo.name == '') {
        this.error = 'Llene el nombre o razón social del solicitante';
        return;
      }

      if (this.formData.subscriptorInfo.celphoneNumber == '') {
        this.error = 'Escriba su número celular';
        return;
      }
      if (this.formData.subscriptorInfo.celphoneNumber.length < 10) {
        this.error = 'Revise su número de celular, debe tener 10 números';
        return;
      }      
      if (this.formData.subscriptorInfo.celphoneNumberConfirm == '') {
        this.error = 'Confirme su número celular';
        return;
      }
      if (this.formData.subscriptorInfo.celphoneNumber !== this.formData.subscriptorInfo.celphoneNumberConfirm) {
        this.error = 'Los números de celular no coinciden';
        return;
      }
      if (this.formData.subscriptorInfo.celphoneNumber.length < 10) {
        this.error = 'Revise su número de celular, debe tener 10 números';
        return;
      }

      if (this.formData.subscriptorInfo.email == '') {
        this.error = 'Escriba su email';
        return;
      }
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.formData.subscriptorInfo.email)) {
          // Good email
      } else {
          this.error = 'Escriba un email válido';
          return;
      }
      
      if (this.formData.subscriptorInfo.emailConfirm == '') {
        this.error = 'Por favor confirme su email';
        return;
      }
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.formData.subscriptorInfo.emailConfirm)) {
          // Good email
      } else {
          this.error = 'Email de confirmación no válido';
          return;
      }
      if (this.formData.subscriptorInfo.email !== this.formData.subscriptorInfo.emailConfirm) {
        this.error = 'Los email ingresados no coinciden';
        return;
      }

      this.step ++;
      window.scrollTo(0, 0);

    },
    validateStep4(){

      if (this.formData.estateInfo.zoneType == null) {
        this.error = 'Seleccione el tipo de zona de su predio';
        return;
      }

      if (this.formData.estateInfo.nieAccountNumber == '') {
        this.formData.estateInfo.nieAccountNumber == '000'
      }

      if (this.formData.estateInfo.zoneType == 'Rural') {
        
        if (this.formData.estateInfo.latitud == '') {
          this.error = 'Digite la Latitud (N) del predio';
          return;
        }

        if (this.formData.estateInfo.longitud == '') {
          this.error = 'Digite la Longitud (W) del predio';
          return;
        }

        if (this.formData.estateInfo.indications == '') {
          this.error = 'Escriba las indicaciones de acceso al predio';
          return;
        }

      }else{

        if (this.formData.estateInfo.address.streetType == '') {
          this.error = 'Seleccione el tipo de vía de su predio';
          return;
        }

        if (this.formData.estateInfo.address.road1 == '') {
          this.error = 'Digite la vía principal del predio';
          return;
        }

        if (this.formData.estateInfo.address.road1Direction == '') {
          this.error = 'Seleccione la orientación de la vía principal';
          return;
        }

        if (this.formData.estateInfo.address.road2 == '') {
          this.error = 'Digite la vía secundaria del predio';
          return;
        }

        if (this.formData.estateInfo.address.road2Direction == '') {
          this.error = 'Seleccione la orientación de la vía secundaria';
          return;
        }

        if(this.formData.serviceDetail.basicDataConexionPoint != 9 && this.formData.serviceDetail.basicDataConexionPoint != 8){
          if (this.formData.estateInfo.address.streetNumber == '') {
            this.error = 'Digite el número de la calle';
            return;
          }
        }

      }

      if (this.formData.estateInfo.commune == '') {
        this.error = 'Digite la comuna de su predio';
        return;
      }

      if (this.formData.estateInfo.municipality == '') {
        this.error = 'Digite el municipio de su predio';
        return;
      }

      if (this.formData.estateInfo.department == '') {
        this.error = 'Digite el departamento de su predio';
        return;
      }

      if(this.formData.estateInfo.existentEstate == null){
        this.error = 'Especifique si es un predio existente o un proyecto en desarrollo';
        return;
      }

      this.step ++;
      window.scrollTo(0, 0);    

      if(this.formData.serviceDetail.documentModify != ""){
        this.getTypeOfUses();
        this.updateEstateInfo();
      }
    },
    updateEstateInfo(){
        let dataSendAddressEstate = {
          "id": this.formData.estateInfo.address.id,
          "description": this.formData.estateInfo.address.description,
          "road1": this.formData.estateInfo.address.road1,
          "road1Direction": this.formData.estateInfo.address.road1Direction,
          "road2": this.formData.estateInfo.address.road2,
          "road2Direction": this.formData.estateInfo.address.road2Direction,
          "streetNumber": this.formData.estateInfo.address.streetNumber,
          "streetType": this.formData.estateInfo.address.streetType,
          "createdDate": new Date(),
          "editedDate": new Date()
        };
        
        axios.post("address/update", dataSendAddressEstate, {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then((resultEstateAddress) => {
          this.resultEstateAddress = resultEstateAddress.data
          let dataStateInfo = {
            "id": this.formData.estateInfo.id,
            "commune": this.formData.estateInfo.commune,
            "contructionLicence": this.formData.estateInfo.contructionLicence,
            "department": this.formData.estateInfo.department,
            "predioNumber": this.formData.estateInfo.predioNumber,
            "estateInfoCert": this.formData.estateInfo.estateInfoCert,
            "existentEstate": this.formData.estateInfo.existentEstate,
            "indications": this.formData.estateInfo.indications,
            "latitud": this.formData.estateInfo.latitud,
            "longitud": this.formData.estateInfo.longitud,
            "height": this.formData.estateInfo.height,
            "municipality": this.formData.estateInfo.municipality,
            "nieAccountNumber": this.formData.estateInfo.nieAccountNumber,
            "urbanLicence": this.formData.estateInfo.urbanLicence,
            "zoneType": this.formData.estateInfo.zoneType,
            "address": this.resultEstateAddress,
            "createdDate": new Date(),
            "editedDate": new Date()
          }

          axios.post("estateInfo/update", dataStateInfo, {
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            }
          })
          .then((resultEstateInto) => {
            console.log("si se pudo el estateino")
            console.log(resultEstateInto)
          })
        })            
    },

    getTypeOfUses(){

      axios.get("/request/" + this.formData.serviceDetail.documentModify)
      .then(responseIdReq => {
        
        if (responseIdReq.data.length != 0 && responseIdReq.data.typesUseEconomicActivity != null) { 
          axios.get("/typesEconomicActivity/" + responseIdReq.data.typesUseEconomicActivity.id)
          .then(response => { 

            if (response.data.length != 0) { 
              this.formData.typesOfUseAndEconomicActivity.id = response.data.id
              this.formData.typesOfUseAndEconomicActivity.typeUse = response.data.typeUse
              this.formData.typesOfUseAndEconomicActivity.socioEconomic = response.data.socioEconomic
              this.formData.typesOfUseAndEconomicActivity.residencialType = response.data.residencialType
              this.formData.typesOfUseAndEconomicActivity.economicActivity = response.data.economicActivity 
            }
          })
        }
      })      
    },

    validateStep5(){

      if (this.formData.typesOfUseAndEconomicActivity.typeUse == '') {
        this.error = 'Seleccione el tipo de uso de su predio';
        return;
      }

      if (this.formData.typesOfUseAndEconomicActivity.typeUse == 'Residencial' && this.formData.typesOfUseAndEconomicActivity.residencialType == '') {
        this.error = 'Seleccione el tipo de residencias';
        return;
      }

      if (this.formData.typesOfUseAndEconomicActivity.socioEconomic == '') {
        this.error = 'Seleccione el estrato del predio';
        return;
      }

      if (this.formData.typesOfUseAndEconomicActivity.economicActivity == '') {
        this.error = 'Seleccione una actividad económica';
        return;
      }

      if(this.formData.serviceDetail.basicDataConexionPoint == 2 || this.formData.serviceDetail.basicDataConexionPoint == 5 || this.formData.serviceDetail.basicDataConexionPoint == 6){
        this.step ++;
        this.step ++;
      }else{
        this.step ++;
      }

      
      window.scrollTo(0, 0);

      if(this.formData.serviceDetail.documentModify != ""){
        this.getElectricInfrastructure();

        this.updateTypeOfUse();
      }
    },
    updateTypeOfUse(){

      let dataSendTypeOfUse = {
        "id": this.formData.typesOfUseAndEconomicActivity.id,
        "residencialType": this.formData.typesOfUseAndEconomicActivity.residencialType,
        "socioEconomic": this.formData.typesOfUseAndEconomicActivity.socioEconomic,
        "typeUse": this.formData.typesOfUseAndEconomicActivity.typeUse,
        "economicActivity": {
          "id": this.formData.typesOfUseAndEconomicActivity.economicActivity.id
        },
        "createdDate": new Date(),
        "editedDate": new Date()
      }

      axios.post("typesEconomicActivity/update", dataSendTypeOfUse, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then((result) => {
        console.log("si se pudo el type of uses")
        console.log(result)
      })
    },
    getElectricInfrastructure(){

      axios.get("/request/" + this.formData.serviceDetail.documentModify)
      .then(responseIdReq => {
        
        if (responseIdReq.data.length != 0) { 
          axios.get("/electricInfrastructure/" + responseIdReq.data.electricInfrastructure.id)
          .then(response => {
            if (response.data.length != 0) { 
              this.formData.electricInfrastructure.id = response.data.id
              this.formData.electricInfrastructure.closeElectricRed = response.data.closeElectricRed
              this.formData.electricInfrastructure.redDistance = response.data.redDistance
              this.formData.electricInfrastructure.transformerNumber = response.data.transformerNumber                    
            }
          })
        }
      })      
    },
    validateStep6(){
      if (this.formData.electricInfrastructure.closeElectricRed == null) {
        this.error = 'Indique si hay infraestructura eléctrica cerca del predio';
        return;
      }

      this.step ++;
      window.scrollTo(0, 0);
      if(this.formData.serviceDetail.documentModify != ""){
        this.getObservations();
        this.updateElectricInfrastructure();
      }
    },
    updateElectricInfrastructure(){
      let dataSendElectricInfrastructure = {  
          "id": this.formData.electricInfrastructure.id,
          "closeElectricRed": this.formData.electricInfrastructure.closeElectricRed,
          "redDistance": this.formData.electricInfrastructure.redDistance,
          "transformerNumber": this.formData.electricInfrastructure.transformerNumber,
          "createdDate": new Date(),
          "editedDate": new Date()
        }

      axios.post("electricInfrastructure/update", dataSendElectricInfrastructure, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then((result) => {
        console.log("respondio el electric infra")
        console.log(result)
      })
    },
    getObservations(){
      axios.get("/request/" + this.formData.serviceDetail.documentModify)
      .then(responseIdReq => {   
        this.formData.id = responseIdReq.data.id
        this.formData.observations = responseIdReq.data.observactions 
      })      
    },
    validateStep7(){
      
      if (this.formData.serviceDetail.requestedService == '') {
        this.error = 'Indique el tipo de servicio solicitado';
        return;
      }

      if (this.formData.serviceDetail.requestedService <= 7) {
        
        if (this.formData.serviceDetail.chargeRequired == '') {
          this.error = 'Indique la carga kW requerida';
          return;
        }

        if (this.formData.serviceDetail.chargeExistent == '') {
          this.error = 'Indique la carga kW existente, si no hay carga kW colocar 0';
          return;
        }

      }else{
        this.formData.serviceDetail.chargeRequired = '-';
        this.formData.serviceDetail.chargeExistent = '-';
      }

      if (this.formData.serviceDetail.requestedService == 10) {

        if (this.formData.serviceDetail.realStateRegistration == '') {
          this.error = 'Indique el número de matrícula inmobiliaria';
          return;
        }

        if (this.formData.serviceDetail.areaMt2 == '') {
          this.error = 'Indique el número de predial';
          return;
        }

        if (this.formData.serviceDetail.numbeUsers == '' || this.formData.serviceDetail.numbeUsers == 0) {
          this.error = 'Indique el número de usuarios';
          return;
        }

        if (this.formData.serviceDetail.nodoReference == '') {
          this.error = 'Indique el nodo de referencia, si no lo conoce colocar 0';
          return;
        }

        if (this.formData.serviceDetail.nodoReference.length < 7) {
          this.error = 'El nodo de referencia debe contener 7 dígitos';
          return;
        }

        if (this.formData.serviceDetail.capacityKvaSolicited == '') {
          this.error = 'Indique la capacidad en kVA solicitada';
          return;
        }
          
      }

      if (this.formData.serviceDetail.requestedService == 9) {

        if (this.formData.serviceDetail.realStateRegistration == '') {
          this.error = 'Indique el número de matrícula inmobiliaria';
          return;
        }

        if (this.formData.serviceDetail.areaMt2 == '') {
          this.error = 'Indique el área bruta Mt2';
          return;
        }

        if (this.formData.serviceDetail.numbeUsers == '' || this.formData.serviceDetail.numbeUsers == 0) {
          this.error = 'Indique el número de usuarios';
          return;
        }

        if (this.formData.serviceDetail.nodoReference == '') {
          this.error = 'Indique el nodo de referencia, si no lo conoce colocar 0';
          return;
        }

        if (this.formData.serviceDetail.nodoReference.length < 7) {
          this.error = 'El nodo de referencia debe contener 7 dígitos';
          return;
        }
          
      }

      if (this.formData.serviceDetail.requestedService == 8) {

        if (this.formData.serviceDetail.basicDataConexionPoint == '') {
          this.error = 'Seleccione el punto de conexión (Datos básicos)';
          return;
        }

        if (this.formData.serviceDetail.basicDataConexionPoint == 1) {

          if (this.formData.serviceDetail.numbeUsers == '') {
            this.error = 'Indique el número de usuarios';
            return;
          }

          if (this.formData.serviceDetail.capacityTransformerInstall == '') {
            this.error = 'Indique la Carga total solicitada (kVA)';
            return;
          }

          if (this.formData.serviceDetail.nodoReference == '') {
            this.error = 'Indique el nodo de referencia, si no lo sabe colocar 0';
            return;
          }

          if (this.formData.serviceDetail.nodoReference.length < 7) {
          this.error = 'El nodo de referencia debe contener 7 dígitos';
          return;
        }

        }

        if (this.formData.serviceDetail.basicDataConexionPoint == 2) {

          if (this.formData.serviceDetail.contractNumber == '') {
            this.error = 'Indique el número de contrato';
            return;
          }

          if (this.formData.serviceDetail.transformerNumber == '') {
            this.error = 'Indique el número del transformador';
            return;
          }

          if (this.formData.serviceDetail.transformerType == '') {
            this.error = 'Indique el tipo de transformador';
            return;
          }

          if (this.formData.serviceDetail.nodo == '') {
            this.error = 'Indique el número del nodo';
            return;
          }

          if (this.formData.serviceDetail.capacityTransformer == '') {
            this.error = 'Indique la capacidad del transformador';
            return;
          }

          if (this.formData.serviceDetail.capacityTransformerInstall == '') {
            this.error = 'Indique la Carga total solicitada (kVA)';
            return;
          }

        }

        if (this.formData.serviceDetail.basicDataConexionPoint == 3) {

          if (this.formData.serviceDetail.capacityTransformerInstall == '') {
            this.error = 'Indique la Carga total solicitada (kVA)';
            return;
          }

          if (this.formData.serviceDetail.nodoReference == '') {
            this.error = 'Indique el nodo de referencia, si no lo sabe colocar 0';
            return;
          }
          if (this.formData.serviceDetail.nodoReference.length < 7) {
          this.error = 'El nodo de referencia debe contener 7 dígitos';
          return;
        }

        }

        if (this.formData.serviceDetail.basicDataConexionPoint == 4) {

          if (this.formData.serviceDetail.documentModify == '') {
            this.error = 'Indique el número de documento a modificar';
            return;
          }

        }

        if (this.formData.serviceDetail.basicDataConexionPoint == 5) {

          if (this.formData.serviceDetail.transformerNumber == '') {
            this.error = 'Indique el número del transformador';
            return;
          }          

          if (this.formData.serviceDetail.transformerType == '') {
            this.error = 'Indique el tipo de transformador';
            return;
          }

          if (this.formData.serviceDetail.nodo == '') {
            this.error = 'Indique el número del nodo';
            return;
          }

          if (this.formData.serviceDetail.capacityTransformer == '') {
            this.error = 'Indique la capacidad del transformador';
            return;
          }

        }

        if (this.formData.serviceDetail.basicDataConexionPoint == 6) {

          if (this.formData.serviceDetail.transformerNumber == '') {
            this.error = 'Indique el número del transformador';
            return;
          }

          if (this.formData.serviceDetail.transformerType == '') {
            this.error = 'Indique el tipo de transformador';
            return;
          }

          if (this.formData.serviceDetail.nodo == '') {
            this.error = 'Indique el número del nodo';
            return;
          }

          if (this.formData.serviceDetail.capacityTransformer == '') {
            this.error = 'Indique la capacidad del transformador';
            return;
          }

        }

        if (this.formData.serviceDetail.basicDataConexionPoint == 7) {

          if (this.formData.serviceDetail.nodoReference1 == '') {
            this.error = 'Indique el nodo de referencia 1';
            return;
          }

          if (this.formData.serviceDetail.nodoReference1.length <7 ) {
            this.error = 'El nodo de referencia debe contener 7 dígitos';
            return;
          }


          if (this.formData.serviceDetail.nodoReference2 == '') {
            this.error = 'Indique el nodo de referencia 2';
            return;
          }

          if (this.formData.serviceDetail.nodoReference2.length <7 ) {
            this.error = 'El nodo de referencia debe contener 7 dígitos';
            return;
          }

          if (this.formData.serviceDetail.sectionNetwork == '') {
            this.error = 'Indique el tramo de la red a intervenir';
            return;
          }

        }

        if (this.formData.serviceDetail.basicDataConexionPoint == 8) {

          if (this.formData.serviceDetail.numbeUsers == '') {
            this.error = 'Indique el número de luminarias';
            return;
          }

          if (this.formData.serviceDetail.capacityTransformerInstall == '') {
            this.error = 'Indique la Carga total solicitada (kVA)';
            return;
          }

          if (this.formData.serviceDetail.nodoReference == '') {
            this.error = 'Indique el nodo de referencia';
            return;
          }

          if (this.formData.serviceDetail.nodoReference.length < 7) {
          this.error = 'El nodo de referencia debe contener 7 dígitos';
          return;
        }

        }

        if (this.formData.serviceDetail.basicDataConexionPoint == 9) {

          if (this.formData.serviceDetail.numbeUsers == '') {
            this.error = 'Indique el número de luminarias';
            return;
          }

          if (this.formData.serviceDetail.capacityTransformerInstall == '') {
            this.error = 'Indique la Carga total solicitada (kVA)';
            return;
          }

          if (this.formData.serviceDetail.nodoReference == '') {
            this.error = 'Indique el nodo de referencia';
            return;
          }

          if (this.formData.serviceDetail.nodoReference.length < 7) {
          this.error = 'El nodo de referencia debe contener 7 dígitos';
          return;
        }
        }    
      }

      this.step ++;
      window.scrollTo(0, 0);
      
      if(this.formData.serviceDetail.documentModify != ""){
        this.getUserApplicantInfo();
      }
    },
    getUserApplicantInfo(){

      axios.get("/request/" + this.formData.serviceDetail.documentModify)
      .then(responseIdReq => {
        if (responseIdReq.data.length != 0) { 
          axios.get("/applicantInfo/" + responseIdReq.data.applicantInfo.id)
          .then(response => {
            if (response.data.length != 0) {
              this.formData.applicantInfo.id = response.data.id
              this.formData.applicantInfo.name = response.data.name
              this.formData.applicantInfo.documentType = response.data.documentType
              this.formData.applicantInfo.personType = response.data.personType
              this.formData.applicantInfo.documentNumber = response.data.documentNumber
              this.formData.applicantInfo.address.id = response.data.address.id
              this.formData.applicantInfo.address.streetType = response.data.address.streetType
              this.formData.applicantInfo.address.road1 = response.data.address.road1
              this.formData.applicantInfo.address.road1Direction = response.data.address.road1Direction
              this.formData.applicantInfo.address.road2 = response.data.address.road2
              this.formData.applicantInfo.address.road2Direction = response.data.address.road2Direction
              this.formData.applicantInfo.address.streetNumber = response.data.address.streetNumber
              this.formData.applicantInfo.address.description = response.data.address.description
              this.formData.applicantInfo.commune = response.data.commune
              this.formData.applicantInfo.municipality = response.data.municipality
              this.formData.applicantInfo.department = response.data.department
              this.formData.applicantInfo.email = response.data.email
              this.formData.applicantInfo.celphoneNumber = response.data.celphoneNumber
              this.formData.applicantInfo.phone = response.data.phone
              this.formData.applicantInfo.solicitantSameSubscriptor = response.data.solicitantSameSubscriptor
              this.formData.applicantInfo.mailNotificationsAuth = response.data.mailNotificationsAuth 
            }

            axios.get("/address/" + this.formData.applicantInfo.address.id)
            .then(responseIdReq => {
                
            })
          })
        }
      })      
    },
    createRequest() {
      this.loading = true;
      this.createApplicantAddress();
      //this.updateObser();
    },
    updateObser(){
      var idEconomicActivity = this.typesUseEconomicActivity != null ? this.typesUseEconomicActivity.id : 0;
      console.log("####### this.applicantInfo.id =" + this.applicantInfo.id);

      let requestData = {
        "conectionType": this.formData.conectionType,
        "proyectName": this.formData.proyectName,
        "observactions": this.formData.observations,
        "status": "en proceso",
        "stage": "factibilidad-servicio",
        "applicantInfo": {
          "id": this.applicantInfo.id
        },
        "electricInfrastructure": {
          "id": this.electricInfrastructure.id
        },
        "estateInfo": {
          "id": this.estateInfo.id
        },
        "serviceDetail": {
          "id": this.serviceDetail.id
        },
        "subscriptorInfo": {
          "id": this.subscriptorInfo.id
        },
        "typesUseEconomicActivity": {
          "id": idEconomicActivity
        },
        "createdDate": new Date(),
        "editedDate": new Date()
      }

      axios.post("request/update", requestData, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then((resultRequest) => {

      })
    },
    createApplicantAddress(){
      let dataSendAddress = {
        "id": this.formData.applicantInfo.address.id,
        "description": this.formData.applicantInfo.address.description,
        "road1": this.formData.applicantInfo.address.road1,
        "road1Direction": this.formData.applicantInfo.address.road1Direction,
        "road2": this.formData.applicantInfo.address.road2,
        "road2Direction": this.formData.applicantInfo.address.road2Direction,
        "streetNumber": this.formData.applicantInfo.address.streetNumber,
        "streetType": this.formData.applicantInfo.address.streetType,
        "createdDate": new Date(),
        "editedDate": new Date()
      };

      axios.post("address/add", dataSendAddress, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json' 
        }
      })
      .then((resultApplicantAddress) => {
        this.applicantAddress = resultApplicantAddress.data;
        this.createApplicantPost();

      })
    },
    createApplicantPost(){
      let dataSendApplicant = {
          "authLetter": this.formData.applicantInfo.authLetter,
          "documentLetterName": this.formData.applicantInfo.authLetterName,
          "celphoneNumber": this.formData.applicantInfo.celphoneNumber,
          "commune": this.formData.applicantInfo.commune,
          "department": this.formData.applicantInfo.department.toLocaleUpperCase(),
          "documentNumber": this.formData.applicantInfo.documentNumber,
          "documentType": this.formData.applicantInfo.documentType,
          "email": this.formData.applicantInfo.email,
          "idCard": this.formData.applicantInfo.idCard,
          "camaraComercio": this.formData.applicantInfo.camaraComercio,
          "documentNameCamara": this.formData.applicantInfo.camaraComercioName,
          "documentPointConection": this.formData.applicantInfo.documentPointConection,
          "documentNameConection": this.formData.applicantInfo.documentPointConectionName,
          "idDocumentCopy": this.formData.applicantInfo.idDocumentCopy,
          "documentNameDocument": this.formData.applicantInfo.idDocumentCopyName,
          "juridicType": this.formData.applicantInfo.juridicType,
          "mailNotificationsAuth": this.formData.applicantInfo.mailNotificationsAuth,
          "municipality": this.formData.applicantInfo.municipality,
          "name": this.formData.applicantInfo.name,
          "naturalPersonRepresentantId": null,
          "personType": this.formData.applicantInfo.personType,
          "phone": this.formData.applicantInfo.phone,
          "solicitantSameSubscriptor": this.formData.applicantInfo.solicitantSameSubscriptor,
          "address": this.applicantAddress,
          "createdDate": new Date(),
          "editedDate": new Date()
        }
 
        axios.post("applicantInfo/add", dataSendApplicant, {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json' 
          }
        })
        .then((applicantInfo) => {
          this.applicantInfo = applicantInfo.data;
          this.createSubscriptorPost();
        })

    },
    createSubscriptorPost(){

      if(this.formData.applicantInfo.solicitantSameSubscriptor == 0){

        let dataSendAddressSubscriptor = {
          "id": this.formData.subscriptorInfo.address.id,
          "description": this.formData.subscriptorInfo.address.description,
          "road1": this.formData.subscriptorInfo.address.road1,
          "road1Direction": this.formData.subscriptorInfo.address.road1Direction,
          "road2": this.formData.subscriptorInfo.address.road2,
          "road2Direction": this.formData.subscriptorInfo.address.road2Direction,
          "streetNumber": this.formData.subscriptorInfo.address.streetNumber,
          "streetType": this.formData.subscriptorInfo.address.streetType,
          "createdDate": new Date(),
          "editedDate": new Date()
        };
        
        axios.post("address/add", dataSendAddressSubscriptor, {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then((resultSubscriptorAddress) => {

          this.resultSubscriptorAddress = resultSubscriptorAddress.data;

          let dataSendSubscriptorInfo = {
            "celphoneNumber": this.formData.subscriptorInfo.celphoneNumber,
            "commune": this.formData.subscriptorInfo.commune,
            "department": this.formData.subscriptorInfo.department,
            "documentNumber": this.formData.subscriptorInfo.documentNumber,
            "documentType": this.formData.subscriptorInfo.documentType,
            "email": this.formData.subscriptorInfo.email,
            "idDocumentCopy": this.formData.subscriptorInfo.idDocumentCopy,
            "documentNameDocument": this.formData.subscriptorInfo.idDocumentCopyName,
            "juridicType": this.formData.subscriptorInfo.juridicType,
            "mailNotificationsAuth": this.formData.subscriptorInfo.mailNotificationsAuth,
            "municipality": this.formData.subscriptorInfo.municipality,
            "name": this.formData.subscriptorInfo.name,
            // "naturalPersonOrRepresentantId": this.formData.subscriptorInfo.naturalPersonOrRepresentantId,
            "naturalPersonOrRepresentantId": null,
            "camaraComercio": this.formData.subscriptorInfo.camaraComercio,
            "documentNameCamara": this.formData.subscriptorInfo.camaraComercioName,
            "personType": this.formData.subscriptorInfo.personType,
            "phone": this.formData.subscriptorInfo.phone,
            "address": this.resultSubscriptorAddress,
            "createdDate": new Date(),
            "editedDate": new Date()
          }

          axios.post("subscriptorInfo/add", dataSendSubscriptorInfo, {
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            }
          })
          .then((resultSubscriptorInfo) => {
            this.subscriptorInfo = resultSubscriptorInfo.data;
            this.createStateInfoPost();
          })
        })

      }else{
        let dataSendSubscriptorInfo = {
          "celphoneNumber": this.formData.subscriptorInfo.celphoneNumber,
          "commune": this.formData.subscriptorInfo.commune,
          "department": this.formData.subscriptorInfo.department,
          "documentNumber": this.formData.subscriptorInfo.documentNumber,
          "documentType": this.formData.subscriptorInfo.documentType,
          "email": this.formData.subscriptorInfo.email,
          "idDocumentCopy": this.formData.subscriptorInfo.idDocumentCopy,
          "documentNameDocument": this.formData.subscriptorInfo.idDocumentCopyName,
          "juridicType": this.formData.subscriptorInfo.juridicType,
          "mailNotificationsAuth": this.formData.subscriptorInfo.mailNotificationsAuth,
          "municipality": this.formData.subscriptorInfo.municipality,
          "name": this.formData.subscriptorInfo.name,
          // "naturalPersonOrRepresentantId": this.formData.subscriptorInfo.naturalPersonOrRepresentantId,
          "naturalPersonOrRepresentantId": null,
          "camaraComercio": this.formData.subscriptorInfo.camaraComercio,
          "personType": this.formData.subscriptorInfo.personType,
          "phone": this.formData.subscriptorInfo.phone,
          "address": this.applicantAddress,
          "createdDate": new Date(),
          "editedDate": new Date()
        }

        axios.post("subscriptorInfo/add", dataSendSubscriptorInfo, {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then((resultSubscriptorInfo) => {
          this.subscriptorInfo = resultSubscriptorInfo.data;
          this.createStateInfoPost();
        })
      }
    },
    createStateInfoPost(){

      if (this.formData.estateInfo.zoneType == 'Urbana') {

            this.formData.estateInfo.indications = '-';
            this.formData.estateInfo.latitud = '-';
            this.formData.estateInfo.longitud = '-';
            this.formData.estateInfo.height = '-';
            
            let dataSendAddressEstate = {
              "id": this.formData.estateInfo.address.id,
              "description": this.formData.estateInfo.address.description,
              "road1": this.formData.estateInfo.address.road1,
              "road1Direction": this.formData.estateInfo.address.road1Direction,
              "road2": this.formData.estateInfo.address.road2,
              "road2Direction": this.formData.estateInfo.address.road2Direction,
              "streetNumber": this.formData.estateInfo.address.streetNumber,
              "streetType": this.formData.estateInfo.address.streetType,
              "createdDate": new Date(),
              "editedDate": new Date()
            };

            axios.post("address/add", dataSendAddressEstate, {
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              }
            })
            .then((resultEstateAddress) => {
              
              this.resultEstateAddress = resultEstateAddress.data;

              let dataStateInfo = {
                "commune": this.formData.estateInfo.commune,
                "contructionLicence": this.formData.estateInfo.contructionLicence,
                "department": this.formData.estateInfo.department,
                "predioNumber": this.formData.estateInfo.predioNumber,
                "estateInfoCert": this.formData.estateInfo.estateInfoCert,
                "documentName": this.formData.estateInfo.estateInfoCertName,
                "existentEstate": this.formData.estateInfo.existentEstate,
                "indications": this.formData.estateInfo.indications,
                "latitud": this.formData.estateInfo.latitud,
                "longitud": this.formData.estateInfo.longitud,
                "height": this.formData.estateInfo.height,
                "municipality": this.formData.estateInfo.municipality,
                "nieAccountNumber": this.formData.estateInfo.nieAccountNumber,
                "urbanLicence": this.formData.estateInfo.urbanLicence,
                "zoneType": this.formData.estateInfo.zoneType,
                "address": this.resultEstateAddress,
                "createdDate": new Date(),
                "editedDate": new Date()
              }

              axios.post("estateInfo/add", dataStateInfo, {
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json'
                }
              })
              .then((resultEstateInto) => {
                this.estateInfo = resultEstateInto.data;
                this.economicActivityPost();
              })

            })

          }else{

            let dataStateInfo = {
              "commune": this.formData.estateInfo.commune,
              "contructionLicence": this.formData.estateInfo.contructionLicence,
              "department": this.formData.estateInfo.department,
              "predioNumber": this.formData.estateInfo.predioNumber,
              "estateInfoCert": this.formData.estateInfo.estateInfoCert,
              "documentName": this.formData.estateInfo.estateInfoCertName,
              "existentEstate": this.formData.estateInfo.existentEstate,
              "indications": this.formData.estateInfo.indications,
              "latitud": this.formData.estateInfo.latitud,
              "longitud": this.formData.estateInfo.longitud,
              "height": this.formData.estateInfo.height,
              "municipality": this.formData.estateInfo.municipality,
              "nieAccountNumber": this.formData.estateInfo.nieAccountNumber,
              "urbanLicence": this.formData.estateInfo.urbanLicence,
              "zoneType": this.formData.estateInfo.zoneType,
              "address": this.applicantAddress,
              "createdDate": new Date(),
              "editedDate": new Date()
            }

            axios.post("estateInfo/add", dataStateInfo, {
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              }
            })
            .then((resultEstateInfo) => {
              this.estateInfo = resultEstateInfo.data;
              this.economicActivityPost();
            })

          }

    },
    economicActivityPost(){

      if(this.formData.serviceDetail.documentModify == ""){
          let dataEconomicActivity = {
          "id": this.formData.typesOfUseAndEconomicActivity.id,
          "residencialType": this.formData.typesOfUseAndEconomicActivity.residencialType,
          "socioEconomic": this.formData.typesOfUseAndEconomicActivity.socioEconomic,
          "typeUse": this.formData.typesOfUseAndEconomicActivity.typeUse,
          //"economicActivity": this.formData.typesOfUseAndEconomicActivity.economicActivity,
          "economicActivity": {
            "id": this.formData.typesOfUseAndEconomicActivity.economicActivity
          },
          "createdDate": new Date(),
          "editedDate": new Date()
        }
        

      axios.post("typesEconomicActivity/add", dataEconomicActivity, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then((resultTypesEconomicActivity) => {
        this.typesUseEconomicActivity = resultTypesEconomicActivity.data;
        this.electricInfrastructurePost();
      })
      }else{
        let dataEconomicActivity = {
          "id": this.formData.typesOfUseAndEconomicActivity.id,
          "residencialType": this.formData.typesOfUseAndEconomicActivity.residencialType,
          "socioEconomic": this.formData.typesOfUseAndEconomicActivity.socioEconomic,
          "typeUse": this.formData.typesOfUseAndEconomicActivity.typeUse,
          //"economicActivity": this.formData.typesOfUseAndEconomicActivity.economicActivity,
          "economicActivity": {
            "id": this.formData.typesOfUseAndEconomicActivity.economicActivity
          },
          "createdDate": new Date(),
          "editedDate": new Date()
        }
        
      axios.post("typesEconomicActivity/add", dataEconomicActivity, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then((resultTypesEconomicActivity) => {
        this.typesUseEconomicActivity = resultTypesEconomicActivity.data;
        this.electricInfrastructurePost();
      })
      }
    },
    electricInfrastructurePost(){

      let dataElectricInfrastructure = {
        "closeElectricRed": this.formData.electricInfrastructure.closeElectricRed,
        "redDistance": this.formData.electricInfrastructure.redDistance,
        "transformerNumber": this.formData.electricInfrastructure.transformerNumber,
        "createdDate": new Date(),
        "editedDate": new Date()
      }

      axios.post("electricInfrastructure/add", dataElectricInfrastructure, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then((resultElectricInfrastructure) => {
        this.electricInfrastructure = resultElectricInfrastructure.data;
        this.detailService();
      })

    },
    detailService(){

      if (this.formData.conectionType == 'Simple') {
        this.formData.serviceDetail.areaMt2 = '111'
      }

      let detailService = {
        "activitiesSchedule": '',
        "activitySchedule": this.formData.serviceDetail.activitySchedule,
        "areaMt2": this.formData.serviceDetail.areaMt2,
        "basicDataConexionPoint": this.formData.serviceDetail.basicDataConexionPoint,
        "capacityKvaSolicited": this.formData.serviceDetail.capacityKvaSolicited,
        "capacityTransformer": this.formData.serviceDetail.capacityTransformer,
        "capacityTransformerInstall": this.formData.serviceDetail.capacityTransformerInstall,
        "contractNumber": this.formData.serviceDetail.contractNumber,
        "documentModify": this.formData.serviceDetail.documentModify,
        "generationSistem": this.formData.serviceDetail.generationSistem,
        "nodo": this.formData.serviceDetail.nodo,
        "nodoReference": this.formData.serviceDetail.nodoReference,
        "nodoReference1": this.formData.serviceDetail.nodoReference1,
        "nodoReference2": this.formData.serviceDetail.nodoReference2,
        "numbeUsers": parseInt(this.formData.serviceDetail.numbeUsers),
        "realStateRegistration": this.formData.serviceDetail.realStateRegistration,
        "sectionNetwork": this.formData.serviceDetail.sectionNetwork,
        "substationType": this.formData.serviceDetail.substationType,
        "tensionRequiere": this.formData.serviceDetail.tensionRequiere,
        "transformerNumber": this.formData.serviceDetail.transformerType + this.formData.serviceDetail.transformerNumber,
        "transformerRecall": this.formData.serviceDetail.transformerRecall,
        "chargeRequired": this.formData.serviceDetail.chargeRequired,
        "chargeExistent": this.formData.serviceDetail.chargeExistent,
        "tensionRequested": this.formData.serviceDetail.tensionRequested,
        "kvRequiered": {
          "id": this.formData.serviceDetail.kvRequiered
        },
        "requestedService": {
          "id": this.formData.serviceDetail.requestedService
        },
        "createdDate": new Date(),
        "editedDate": new Date()
      }

      axios.post("serviceDetail/add", detailService, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then((resultServiceDetail) => {
        this.serviceDetail = resultServiceDetail.data;
        this.makeRequest();
      })
    },
    addApplicantInfoDocs() {
      console.log(">>>>>>>>>>> addApplicantInfoDocs.this.formData.idRequest = " + this.formData.idRequest); 
      let dataSendApplicant = {
        "authLetter": this.formData.applicantInfo.authLetter,
        "documentLetterName": this.formData.applicantInfo.authLetterName,
        "celphoneNumber": this.formData.applicantInfo.celphoneNumber,
        "commune": this.formData.applicantInfo.commune,
        "department": this.formData.applicantInfo.department.toLocaleUpperCase(),
        "documentNumber": this.formData.applicantInfo.documentNumber,
        "documentType": this.formData.applicantInfo.documentType,
        "email": this.formData.applicantInfo.email,
        "idCard": this.formData.applicantInfo.idCard,
        "camaraComercio": this.formData.applicantInfo.camaraComercio,
        "documentNameCamara": this.formData.applicantInfo.camaraComercioName,
        "documentPointConection": this.formData.applicantInfo.documentPointConection,
        "documentNameConection": this.formData.applicantInfo.documentPointConectionName,
        "idDocumentCopy": this.formData.applicantInfo.idDocumentCopy,
        "documentNameDocument": this.formData.applicantInfo.idDocumentCopyName,
        "juridicType": this.formData.applicantInfo.juridicType,
        "mailNotificationsAuth": this.formData.applicantInfo.mailNotificationsAuth,
        "municipality": this.formData.applicantInfo.municipality,
        "name": this.formData.applicantInfo.name,
        "naturalPersonRepresentantId": null,
        "personType": this.formData.applicantInfo.personType,
        "phone": this.formData.applicantInfo.phone,
        "solicitantSameSubscriptor": this.formData.applicantInfo.solicitantSameSubscriptor,
        "address": this.applicantAddress,
        "createdDate": new Date(),
        "editedDate": new Date(),
        "idRequest": this.formData.idRequest
      };

        axios.post("applicantInfo/adddocs", dataSendApplicant, {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json' 
          }
        })
        .then((applicantInfo) => {
          //console.log("Archivos agregados a applicantInfo");
          
        })
    },
    addSubscriptorInfoDocs() {
      //console.log(">>>>>>>>>>> SubscriptorInfo.this.formData.idRequest = " + this.formData.idRequest); 
      let dataSendSubscriptorInfo = {
          "celphoneNumber": this.formData.subscriptorInfo.celphoneNumber,
          "commune": this.formData.subscriptorInfo.commune,
          "department": this.formData.subscriptorInfo.department,
          "documentNumber": this.formData.subscriptorInfo.documentNumber,
          "documentType": this.formData.subscriptorInfo.documentType,
          "email": this.formData.subscriptorInfo.email,
          "idDocumentCopy": this.formData.subscriptorInfo.idDocumentCopy,
          "documentNameDocument": this.formData.subscriptorInfo.idDocumentCopyName,
          "juridicType": this.formData.subscriptorInfo.juridicType,
          "mailNotificationsAuth": this.formData.subscriptorInfo.mailNotificationsAuth,
          "municipality": this.formData.subscriptorInfo.municipality,
          "name": this.formData.subscriptorInfo.name,
          "naturalPersonOrRepresentantId": null,
          "camaraComercio": this.formData.subscriptorInfo.camaraComercio,
          "documentNameCamara": this.formData.subscriptorInfo.camaraComercioName,
          "personType": this.formData.subscriptorInfo.personType,
          "phone": this.formData.subscriptorInfo.phone,
          "address": this.applicantAddress,
          "createdDate": new Date(),
          "editedDate": new Date(),
          "idRequest": this.formData.idRequest          
        }

        axios.post("subscriptorInfo/adddocs", dataSendSubscriptorInfo, {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json' 
          }
        })
        .then((applicantInfo) => {
          console.log("Archivos agregados a subscriptorInfo");
          
        })
    },
    makeRequest(){
      var idEconomicActivity = this.typesUseEconomicActivity != null ? this.typesUseEconomicActivity.id : 0;

      let requestData = {
        "conectionType": this.formData.conectionType,
        "proyectName": this.formData.proyectName,
        "observactions": this.formData.observations,
        "status": "en proceso",
        "stage": "factibilidad-servicio",
        "applicantInfo": {
          "id": this.applicantInfo.id
        },
        "electricInfrastructure": {
          "id": this.electricInfrastructure.id
        },
        "estateInfo": {
          "id": this.estateInfo.id
        },
        "serviceDetail": {
          "id": this.serviceDetail.id
        },
        "subscriptorInfo": {
          "id": this.subscriptorInfo.id
        },
        "typesUseEconomicActivity": {
          "id": idEconomicActivity
        },
        "createdDate": new Date(),
        "editedDate": new Date(),
        "fechaOperacion": this.formData.dateInicioOperacion
      };

      axios.post("request/add", requestData, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then((resultRequest) => {

        this.loading = false;
        let tiposcarga = {
          "idRequest": resultRequest.data.id,
          "residencial": this.valoresTiposCarga.residencial,
          "comercial": this.valoresTiposCarga.comercial,
          "industrial": this.valoresTiposCarga.industrial,
          "oficial": this.valoresTiposCarga.oficial,
          "alumbradoPublico": this.valoresTiposCarga.alumbradoPublico,
          "provisionalObra": this.valoresTiposCarga.provisionalObra,
          "otro": this.valoresTiposCarga.otro,
        };
        
        axios.post("tipocarga/add", tiposcarga, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
        })
        .then((result) => {
          this.formData.idRequest = resultRequest.data.id;
          this.addApplicantInfoDocs();
          this.addSubscriptorInfoDocs();
          this.$router.push('/success');
        })
      })
    },
    resetConectionType(){
      this.formData.serviceDetail.basicDataConexionPoint = '';
    },
    nextStep(){
      this.step ++;
      window.scrollTo(0, 0);
    },
    prevStep(){
      this.step --;
      window.scrollTo(0, 0);
    },
    onFileChangeActivitySchedule(event) {
      let files = event.target.files[0];
      this.formData.serviceDetail.activitySchedule = files;
      if (!files.length){
        return;
      }
    },
    onFileChangeIdDocSubscriptor(event){
      let files = event.target.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(files);
      reader.onload = () => {
        this.formData.subscriptorInfo.idDocumentCopy = reader.result;
      };
      reader.onerror = function (error) {
        console.log('Error: ', error);
      };
      this.formData.subscriptorInfo.idDocumentCopyFile = files;
      this.formData.subscriptorInfo.idDocumentCopyName = files.name;
    },
    onFileChangeNaturalPersonOrRepresentantIdSubscriptor(event){
      let files = event.target.files[0];
      this.formData.subscriptorInfo.naturalPersonOrRepresentantId = files;
      if (!files.length){
        return;
      }
    },
    onFileChangeIdDocApplicant(event){
      let files = event.target.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(files);
      reader.onload = () => {
        this.formData.applicantInfo.idDocumentCopy = reader.result;
      };
      reader.onerror = function (error) {
        console.log('Error: ', error);
      };
      this.formData.applicantInfo.idDocumentCopyFile = files;
      this.formData.applicantInfo.idDocumentCopyName = files.name;
    },
    onFileChangeNaturalPersonOrRepresentantIdApplicant(event) {
      let files = event.target.files[0];
      this.formData.applicantInfo.naturalPersonOrRepresentantId = files;
      if (!files.length){
        return;
      }
    },
    onFileIdCardApplicant(event){
      let files = event.target.files[0];
      this.formData.applicantInfo.idCard = files;
      if (!files.length){
        return;
      }
    },
    onFileChangeAuthLetter(event){
      let files = event.target.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(files);
      reader.onload = () => {
        this.formData.applicantInfo.authLetter  = reader.result;
      };
      reader.onerror = function (error) {
        console.log('Error: ', error);
      };
      this.formData.applicantInfo.authLetterFile = files;
      this.formData.applicantInfo.authLetterName = files.name;
    },
    onFileChangeCamaraComercio(event){
      let files = event.target.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(files);
      reader.onload = () => {
        this.formData.applicantInfo.camaraComercio = reader.result;
      };
      reader.onerror = function (error) {
        console.log('Error: ', error);
      };
      this.formData.applicantInfo.camaraComercioFile = files;
      this.formData.applicantInfo.camaraComercioName = files.name;
    },
    onFileChangeCamaraComerciosuscriptor(event){
      let files = event.target.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(files);
      reader.onload = () => {
        this.formData.subscriptorInfo.camaraComercio = reader.result;
      };
      reader.onerror = function (error) {
        console.log('Error: ', error);
      };
      this.formData.subscriptorInfo.camaraComercioFile = files;
      this.formData.subscriptorInfo.camaraComercioName = files.name;
    },
    onFileChangeEstateInfoCert(event){
      let files = event.target.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(files);
      reader.onload = () => {
        this.formData.estateInfo.estateInfoCert = reader.result;
      };
      reader.onerror = function (error) {
        console.log('Error: ', error);
      };
      this.formData.estateInfo.estateInfoCertFile = files;
      this.formData.estateInfo.estateInfoCertName = files.name;
    },
    onFiledocumentPointConection(event){
      let files = event.target.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(files);
      reader.onload = () => {
        this.formData.applicantInfo.documentPointConection  = reader.result;
      };
      reader.onerror = function (error) {
        console.log('Error: ', error);
      };
      this.formData.applicantInfo.documentPointConectionFile  = files;
      this.formData.applicantInfo.documentPointConectionName  = files.name;
    },
    onFileChangeUrbanLicence(event){
      let files = event.target.files[0];
      this.formData.estateInfo.urbanLicence = files;
      if (!files.length){
        return;
      }
    },
    onFileChangeContructionLicence(event){
      let files = event.target.files[0];
      this.formData.estateInfo.contructionLicence = files;
      if (!files.length){
        return;
      }
    },
  }
}
</script>

<style lang="scss">
.form {
  padding: 50px 0;  
}
</style>